var items = {
  "block.minecraft.acacia_button": "Акацовый ґомбик",
  "block.minecraft.acacia_door": "Акацові двирі",
  "block.minecraft.acacia_fence": "Акацовый плут",
  "block.minecraft.acacia_fence_gate": "Акацова капура",
  "block.minecraft.acacia_hanging_sign": "Акацова увіска",
  "block.minecraft.acacia_leaves": "Акацовоє листя",
  "block.minecraft.acacia_log": "Акацовый кымак",
  "block.minecraft.acacia_planks": "Акацові дощкы",
  "block.minecraft.acacia_pressure_plate": "Акацова ступова пластина",
  "block.minecraft.acacia_sapling": "Скіпиць акаца",
  "block.minecraft.acacia_shelf": "Акацова полиця",
  "block.minecraft.acacia_sign": "Акацова табличка",
  "block.minecraft.acacia_slab": "Акацова плита",
  "block.minecraft.acacia_stairs": "Акацові ґарадічі",
  "block.minecraft.acacia_trapdoor": "Акацовый пролаз",
  "block.minecraft.acacia_wall_hanging_sign": "Акацова стінна увіска",
  "block.minecraft.acacia_wall_sign": "Акацова стінна табличка",
  "block.minecraft.acacia_wood": "Акацовоє дерево",
  "block.minecraft.activator_rail": "Колия-активатор",
  "block.minecraft.air": "Воздух",
  "block.minecraft.allium": "Плодисток",
  "block.minecraft.amethyst_block": "Аметістовый блок",
  "block.minecraft.amethyst_cluster": "Аметістова друза",
  "block.minecraft.ancient_debris": "Престарый крех",
  "block.minecraft.andesite": "Андезіт",
  "block.minecraft.andesite_slab": "Андезітова плита",
  "block.minecraft.andesite_stairs": "Андезітові ґарадічі",
  "block.minecraft.andesite_wall": "Андезітовый мур",
  "block.minecraft.anvil": "Ковало",
  "block.minecraft.attached_melon_stem": "Прикапчаноє коріня грызачкы",
  "block.minecraft.attached_pumpkin_stem": "Прикапчаноє дынёвоє коріня",
  "block.minecraft.azalea": "Азалія",
  "block.minecraft.azalea_leaves": "Листя азалії",
  "block.minecraft.azure_bluet": "Гаустонія синя",
  "block.minecraft.bamboo": "Бамбус",
  "block.minecraft.bamboo_block": "Блок бамбуса",
  "block.minecraft.bamboo_button": "Бамбусовый ґомбик",
  "block.minecraft.bamboo_door": "Бамбусові двирі",
  "block.minecraft.bamboo_fence": "Бамбусовый плут",
  "block.minecraft.bamboo_fence_gate": "Бамбусова капурка",
  "block.minecraft.bamboo_hanging_sign": "Бамбусова увіска",
  "block.minecraft.bamboo_mosaic": "Бамбусовый мозаик",
  "block.minecraft.bamboo_mosaic_slab": "Бамбусова мозаикова плита",
  "block.minecraft.bamboo_mosaic_stairs": "Бамбусові мозаикові ґарадічі",
  "block.minecraft.bamboo_planks": "Бамбусові дощкы",
  "block.minecraft.bamboo_pressure_plate": "Бамбусова ступова пластина",
  "block.minecraft.bamboo_sapling": "Скіпиць бамбуса",
  "block.minecraft.bamboo_shelf": "Бамбусова полиця",
  "block.minecraft.bamboo_sign": "Бамбусова табличка",
  "block.minecraft.bamboo_slab": "Бамбусова плита",
  "block.minecraft.bamboo_stairs": "Бамбусові ґарадічі",
  "block.minecraft.bamboo_trapdoor": "Бамбусовый пролаз",
  "block.minecraft.bamboo_wall_hanging_sign": "Бамбусова стінна увіска",
  "block.minecraft.bamboo_wall_sign": "Бамбусова стінна табличка",
  "block.minecraft.banner.base.black": "Чорноє поле",
  "block.minecraft.banner.base.blue": "Синёє поле",
  "block.minecraft.banner.base.brown": "Барнастоє поле",
  "block.minecraft.banner.base.cyan": "Ціановоє поле",
  "block.minecraft.banner.base.gray": "Сіроє поле",
  "block.minecraft.banner.base.green": "Зеленоє поле",
  "block.minecraft.banner.base.light_blue": "Голубоє поле",
  "block.minecraft.banner.base.light_gray": "Світлосіроє поле",
  "block.minecraft.banner.base.lime": "Лаймовоє поле",
  "block.minecraft.banner.base.magenta": "Пурпуровоє поле",
  "block.minecraft.banner.base.orange": "Оранджовоє поле",
  "block.minecraft.banner.base.pink": "Ліловоє поле",
  "block.minecraft.banner.base.purple": "Ліловоє поле",
  "block.minecraft.banner.base.red": "Черленоє поле",
  "block.minecraft.banner.base.white": "Білоє поле",
  "block.minecraft.banner.base.yellow": "Жовтоє поле",
  "block.minecraft.banner.border.black": "Чорна крайка",
  "block.minecraft.banner.border.blue": "Синя крайка",
  "block.minecraft.banner.border.brown": "Барнаста крайка",
  "block.minecraft.banner.border.cyan": "Ціанова крайка",
  "block.minecraft.banner.border.gray": "Сіра крайка",
  "block.minecraft.banner.border.green": "Зелена крайка",
  "block.minecraft.banner.border.light_blue": "Голуба крайка",
  "block.minecraft.banner.border.light_gray": "Світлосіра крайка",
  "block.minecraft.banner.border.lime": "Лаймова крайка",
  "block.minecraft.banner.border.magenta": "Пурпурова крайка",
  "block.minecraft.banner.border.orange": "Оранджова крайка",
  "block.minecraft.banner.border.pink": "Ружова крайка",
  "block.minecraft.banner.border.purple": "Лілова крайка",
  "block.minecraft.banner.border.red": "Черлена крайка",
  "block.minecraft.banner.border.white": "Біла крайка",
  "block.minecraft.banner.border.yellow": "Жовта крайка",
  "block.minecraft.banner.bricks.black": "Чорна цигляна позадина",
  "block.minecraft.banner.bricks.blue": "Синя цигляна позадина",
  "block.minecraft.banner.bricks.brown": "Барнаста цигляна позадина",
  "block.minecraft.banner.bricks.cyan": "Ціанова цигляна позадина",
  "block.minecraft.banner.bricks.gray": "Сіра цигляна позадина",
  "block.minecraft.banner.bricks.green": "Зелена цигляна позадина",
  "block.minecraft.banner.bricks.light_blue": "Голуба цигляна позадина",
  "block.minecraft.banner.bricks.light_gray": "Світлосіра цигляна позадина",
  "block.minecraft.banner.bricks.lime": "Лаймова цигляна позадина",
  "block.minecraft.banner.bricks.magenta": "Пурпурова цигляна позадина",
  "block.minecraft.banner.bricks.orange": "Оранджова цигляна позадина",
  "block.minecraft.banner.bricks.pink": "Ружова цигляна позадина",
  "block.minecraft.banner.bricks.purple": "Лілова цигляна позадина",
  "block.minecraft.banner.bricks.red": "Черлена цигляна позадина",
  "block.minecraft.banner.bricks.white": "Біла цигляна позадина",
  "block.minecraft.banner.bricks.yellow": "Жовта цигляна позадина",
  "block.minecraft.banner.circle.black": "Чорна котуля",
  "block.minecraft.banner.circle.blue": "Синя котуля",
  "block.minecraft.banner.circle.brown": "Барнаста котуля",
  "block.minecraft.banner.circle.cyan": "Ціанова котуля",
  "block.minecraft.banner.circle.gray": "Сіра котуля",
  "block.minecraft.banner.circle.green": "Зелена котуля",
  "block.minecraft.banner.circle.light_blue": "Голуба котуля",
  "block.minecraft.banner.circle.light_gray": "Світлосіра котуля",
  "block.minecraft.banner.circle.lime": "Лаймова котуля",
  "block.minecraft.banner.circle.magenta": "Пурпурова котуля",
  "block.minecraft.banner.circle.orange": "Оранджова котуля",
  "block.minecraft.banner.circle.pink": "Ружова котуля",
  "block.minecraft.banner.circle.purple": "Лілова котуля",
  "block.minecraft.banner.circle.red": "Черлена котуля",
  "block.minecraft.banner.circle.white": "Білый круг",
  "block.minecraft.banner.circle.yellow": "Жовта котуля",
  "block.minecraft.banner.creeper.black": "Чорна значка кріпера",
  "block.minecraft.banner.creeper.blue": "Синя значка кріпера",
  "block.minecraft.banner.creeper.brown": "Барнаста значка кріпера",
  "block.minecraft.banner.creeper.cyan": "Ціанова значка кріпера",
  "block.minecraft.banner.creeper.gray": "Сіра значка кріпера",
  "block.minecraft.banner.creeper.green": "Зелена значка кріпера",
  "block.minecraft.banner.creeper.light_blue": "Голуба значка кріпера",
  "block.minecraft.banner.creeper.light_gray": "Світлосіра значка кріпера",
  "block.minecraft.banner.creeper.lime": "Лаймова значка кріпера",
  "block.minecraft.banner.creeper.magenta": "Пурпурова значка кріпера",
  "block.minecraft.banner.creeper.orange": "Оранджова значка кріпера",
  "block.minecraft.banner.creeper.pink": "Ружова значка кріпера",
  "block.minecraft.banner.creeper.purple": "Лілова значка кріпера",
  "block.minecraft.banner.creeper.red": "Черлена значка кріпера",
  "block.minecraft.banner.creeper.white": "Біла значка кріпера",
  "block.minecraft.banner.creeper.yellow": "Жовта значка кріпера",
  "block.minecraft.banner.cross.black": "Чорный Андріюв хрест",
  "block.minecraft.banner.cross.blue": "Синьый Андріюв хрест",
  "block.minecraft.banner.cross.brown": "Барнастый Андріюв хрест",
  "block.minecraft.banner.cross.cyan": "Ціановый Андріюв хрест",
  "block.minecraft.banner.cross.gray": "Сірый Андріюв хрест",
  "block.minecraft.banner.cross.green": "Зеленый Андріюв хрест",
  "block.minecraft.banner.cross.light_blue": "Голубый Андріюв хрест",
  "block.minecraft.banner.cross.light_gray": "Світлосірый Андріюв хрест",
  "block.minecraft.banner.cross.lime": "Лаймовый Андріюв хрест",
  "block.minecraft.banner.cross.magenta": "Пурпуровый Андріюв хрест",
  "block.minecraft.banner.cross.orange": "Оранджовый Андріюв хрест",
  "block.minecraft.banner.cross.pink": "Ружовый Андріюв хрест",
  "block.minecraft.banner.cross.purple": "Ліловый Андріюв хрест",
  "block.minecraft.banner.cross.red": "Черленый Андріюв хрест",
  "block.minecraft.banner.cross.white": "Білый андріюв хрест",
  "block.minecraft.banner.cross.yellow": "Жовтый Андріюв хрест",
  "block.minecraft.banner.curly_border.black": "Чорна зубковата крайка",
  "block.minecraft.banner.curly_border.blue": "Синя зубковата крайка",
  "block.minecraft.banner.curly_border.brown": "Барнаста зубковата крайка",
  "block.minecraft.banner.curly_border.cyan": "Ціанова зубковата крайка",
  "block.minecraft.banner.curly_border.gray": "Сіра зубковата крайка",
  "block.minecraft.banner.curly_border.green": "Зелена зубковата крайка",
  "block.minecraft.banner.curly_border.light_blue": "Голуба зубковата крайка",
  "block.minecraft.banner.curly_border.light_gray": "Світлосіра зубковата крайка",
  "block.minecraft.banner.curly_border.lime": "Лаймова зубковата крайка",
  "block.minecraft.banner.curly_border.magenta": "Пурпурова зубковата крайка",
  "block.minecraft.banner.curly_border.orange": "Оранджова зубковата крайка",
  "block.minecraft.banner.curly_border.pink": "Лілова зубковата крайка",
  "block.minecraft.banner.curly_border.purple": "Лілова зубковата крайка",
  "block.minecraft.banner.curly_border.red": "Черлена зубковата крайка",
  "block.minecraft.banner.curly_border.white": "Біла зубковата крайка",
  "block.minecraft.banner.curly_border.yellow": "Жовта зубковата крайка",
  "block.minecraft.banner.diagonal_left.black": "Чорный трикутник у лівому вирьхнёму кутови",
  "block.minecraft.banner.diagonal_left.blue": "Синьый трикутник у лівому вирьхнёму кутови",
  "block.minecraft.banner.diagonal_left.brown": "Барнастый трикутник у лівому вирьхнёму кутови",
  "block.minecraft.banner.diagonal_left.cyan": "Ціановый трикутник у лівому вирьхнёму кутови",
  "block.minecraft.banner.diagonal_left.gray": "Сірый трикутник у лівому вирьхнёму кутови",
  "block.minecraft.banner.diagonal_left.green": "Зеленый трикутник у лівому вирьхнёму кутови",
  "block.minecraft.banner.diagonal_left.light_blue": "Голуба ліва нижня лінія",
  "block.minecraft.banner.diagonal_left.light_gray": "Світлосіра ліва нижня лінія",
  "block.minecraft.banner.diagonal_left.lime": "Лаймовый трикутник у лівому вирьхнёму кутови",
  "block.minecraft.banner.diagonal_left.magenta": "Пурпуровый трикутник у лівому вирьхнёму кутови",
  "block.minecraft.banner.diagonal_left.orange": "Оранджовый трикутник у лівому вирьхнёму кутови",
  "block.minecraft.banner.diagonal_left.pink": "Ружовый трикутник у лівому вирьхнёму кутови",
  "block.minecraft.banner.diagonal_left.purple": "Ліловый трикутник у лівому вирьхнёму кутови",
  "block.minecraft.banner.diagonal_left.red": "Черленый трикутник у лівому вирьхнёму кутови",
  "block.minecraft.banner.diagonal_left.white": "Білый трикутник у лівому вирьхнёму кутови",
  "block.minecraft.banner.diagonal_left.yellow": "Жовтый трикутник у лівому вирьхнёму кутови",
  "block.minecraft.banner.diagonal_right.black": "Чорный трикутник у вирьхнёму правому кутови",
  "block.minecraft.banner.diagonal_right.blue": "Синьый трикутник у вирьхнёму правому кутови",
  "block.minecraft.banner.diagonal_right.brown": "Барнастый трикутник у вирьхнёму правому кутови",
  "block.minecraft.banner.diagonal_right.cyan": "Ціановый трикутник у вирьхнёму правому кутови",
  "block.minecraft.banner.diagonal_right.gray": "Сірый трикутник у вирьхнёму правому кутови",
  "block.minecraft.banner.diagonal_right.green": "Зеленый трикутник у вирьхнёму правому кутови",
  "block.minecraft.banner.diagonal_right.light_blue": "Голубый трикутник у вирьхнёму правому кутови",
  "block.minecraft.banner.diagonal_right.light_gray": "Світлосірый трикутник у вирьхнёму правому кутови",
  "block.minecraft.banner.diagonal_right.lime": "Лаймовый трикутник у вирьхнёму правому кутови",
  "block.minecraft.banner.diagonal_right.magenta": "Пурпуровый трикутник у вирьхнёму правому кутови",
  "block.minecraft.banner.diagonal_right.orange": "Оранджовый трикутник у вирьхнёму правому кутови",
  "block.minecraft.banner.diagonal_right.pink": "Ружовый трикутник у вирьхнёму правому кутови",
  "block.minecraft.banner.diagonal_right.purple": "Ліловый трикутник у вирьхнёму правому кутови",
  "block.minecraft.banner.diagonal_right.red": "Черленый трикутник у вирьхнёму правому кутови",
  "block.minecraft.banner.diagonal_right.white": "Білый трикутник у вирьхнёму правому кутови",
  "block.minecraft.banner.diagonal_right.yellow": "Жовтый трикутник у вирьхнёму правому кутови",
  "block.minecraft.banner.diagonal_up_left.black": "Чорный трикутник у нижнёму лівому кутови",
  "block.minecraft.banner.diagonal_up_left.blue": "Синьый трикутник у нижнёму лівому кутови",
  "block.minecraft.banner.diagonal_up_left.brown": "Барнастый трикутник у нижнёму лівому кутови",
  "block.minecraft.banner.diagonal_up_left.cyan": "Ціановый трикутник у нижнёму лівому кутови",
  "block.minecraft.banner.diagonal_up_left.gray": "Сірый трикутник у нижнёму лівому кутови",
  "block.minecraft.banner.diagonal_up_left.green": "Зеленый трикутник у нижнёму лівому кутови",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Голубый трикутник у нижнёму лівому кутови",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Світлосірый трикутник у нижнёму лівому кутови",
  "block.minecraft.banner.diagonal_up_left.lime": "Лаймовый трикутник у нижнёму лівому кутови",
  "block.minecraft.banner.diagonal_up_left.magenta": "Пурпуровый трикутник у нижнёму лівому кутови",
  "block.minecraft.banner.diagonal_up_left.orange": "Оранджовый трикутник у нижнёму лівому кутови",
  "block.minecraft.banner.diagonal_up_left.pink": "Ружовый трикутник у нижнёму лівому кутови",
  "block.minecraft.banner.diagonal_up_left.purple": "Ружовый трикутник у нижнёму лівому кутови",
  "block.minecraft.banner.diagonal_up_left.red": "Черленый трикутник у нижнёму лівому кутови",
  "block.minecraft.banner.diagonal_up_left.white": "Білый трикутник у нижнёму лівому кутови",
  "block.minecraft.banner.diagonal_up_left.yellow": "Жовтый трикутник у нижнёму лівому кутови",
  "block.minecraft.banner.diagonal_up_right.black": "Чорный трикутник у нижнёму правому кутови",
  "block.minecraft.banner.diagonal_up_right.blue": "Синьый трикутник у нижнёму правому кутови",
  "block.minecraft.banner.diagonal_up_right.brown": "Барнастый трикутник у нижнёму правому кутови",
  "block.minecraft.banner.diagonal_up_right.cyan": "Ціановый трикутник у нижнёму правому кутови",
  "block.minecraft.banner.diagonal_up_right.gray": "Сірый трикутник у нижнёму правому кутови",
  "block.minecraft.banner.diagonal_up_right.green": "Зеленый трикутник у нижнёму правому кутови",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Голубый трикутник у нижнёму правому кутови",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Світлосірый трикутник у нижнёму правому кутови",
  "block.minecraft.banner.diagonal_up_right.lime": "Лаймовый трикутник у нижнёму правому кутови",
  "block.minecraft.banner.diagonal_up_right.magenta": "Пурпуровый трикутник у нижнёму правому кутови",
  "block.minecraft.banner.diagonal_up_right.orange": "Оранджовый трикутник у нижнёму правому кутови",
  "block.minecraft.banner.diagonal_up_right.pink": "Ружовый трикутник у нижнёму правому кутови",
  "block.minecraft.banner.diagonal_up_right.purple": "Ліловый трикутник у нижнёму правому кутови",
  "block.minecraft.banner.diagonal_up_right.red": "Черленый трикутник у нижнёму правому кутови",
  "block.minecraft.banner.diagonal_up_right.white": "Білый трикутник у нижнёму правому кутови",
  "block.minecraft.banner.diagonal_up_right.yellow": "Жовтый трикутник у нижнёму правому кутови",
  "block.minecraft.banner.flow.black": "Чорный потук",
  "block.minecraft.banner.flow.blue": "Синьый потук",
  "block.minecraft.banner.flow.brown": "Барнастый потук",
  "block.minecraft.banner.flow.cyan": "Ціановый потук",
  "block.minecraft.banner.flow.gray": "Сірый потук",
  "block.minecraft.banner.flow.green": "Зеленый потук",
  "block.minecraft.banner.flow.light_blue": "Голубый потук",
  "block.minecraft.banner.flow.light_gray": "Світлосірый потук",
  "block.minecraft.banner.flow.lime": "Лаймовый потук",
  "block.minecraft.banner.flow.magenta": "Пурпуровый потук",
  "block.minecraft.banner.flow.orange": "Оранджовый потук",
  "block.minecraft.banner.flow.pink": "Ружовый потук",
  "block.minecraft.banner.flow.purple": "Ліловый потук",
  "block.minecraft.banner.flow.red": "Черленый потук",
  "block.minecraft.banner.flow.white": "Білый потук",
  "block.minecraft.banner.flow.yellow": "Жовтый потук",
  "block.minecraft.banner.flower.black": "Чорна значка косиці",
  "block.minecraft.banner.flower.blue": "Синя значка косиці",
  "block.minecraft.banner.flower.brown": "Барнаста значка косиці",
  "block.minecraft.banner.flower.cyan": "Ціанова значка косиці",
  "block.minecraft.banner.flower.gray": "Сіра значка косиці",
  "block.minecraft.banner.flower.green": "Зелена значка косиці",
  "block.minecraft.banner.flower.light_blue": "Голуба значка косиці",
  "block.minecraft.banner.flower.light_gray": "Світлосіра значка косиці",
  "block.minecraft.banner.flower.lime": "Лаймова значка косиці",
  "block.minecraft.banner.flower.magenta": "Пурпурова значка косиці",
  "block.minecraft.banner.flower.orange": "Оранджова значка косиці",
  "block.minecraft.banner.flower.pink": "Ружова значка косиці",
  "block.minecraft.banner.flower.purple": "Лілова значка косиці",
  "block.minecraft.banner.flower.red": "Черлена значка косиці",
  "block.minecraft.banner.flower.white": "Біла значка косиці",
  "block.minecraft.banner.flower.yellow": "Жовта значка косиці",
  "block.minecraft.banner.globe.black": "Чорный ґлобус",
  "block.minecraft.banner.globe.blue": "Синьый ґлобус",
  "block.minecraft.banner.globe.brown": "Барнастый ґлобус",
  "block.minecraft.banner.globe.cyan": "Ціановый ґлобус",
  "block.minecraft.banner.globe.gray": "Сірый ґлобус",
  "block.minecraft.banner.globe.green": "Зеленый ґлобус",
  "block.minecraft.banner.globe.light_blue": "Голубый ґлобус",
  "block.minecraft.banner.globe.light_gray": "Світлосірый ґлобус",
  "block.minecraft.banner.globe.lime": "Лаймовый ґлобус",
  "block.minecraft.banner.globe.magenta": "Пурпуровый ґлобус",
  "block.minecraft.banner.globe.orange": "Оранджовый ґлобус",
  "block.minecraft.banner.globe.pink": "Ружовый ґлобус",
  "block.minecraft.banner.globe.purple": "Ліловый ґлобус",
  "block.minecraft.banner.globe.red": "Черленый ґлобус",
  "block.minecraft.banner.globe.white": "Білый ґлобус",
  "block.minecraft.banner.globe.yellow": "Жовтый ґлобус",
  "block.minecraft.banner.gradient.black": "Чорный ґрадіент",
  "block.minecraft.banner.gradient.blue": "Синьый ґрадіент",
  "block.minecraft.banner.gradient.brown": "Барнастый ґрадіент",
  "block.minecraft.banner.gradient.cyan": "Ціановый ґрадіент",
  "block.minecraft.banner.gradient.gray": "Сірый ґрадіент",
  "block.minecraft.banner.gradient.green": "Зеленый ґрадіент",
  "block.minecraft.banner.gradient.light_blue": "Голубый ґрадіент",
  "block.minecraft.banner.gradient.light_gray": "Світлосірый ґрадіент",
  "block.minecraft.banner.gradient.lime": "Лаймовый ґрадіент",
  "block.minecraft.banner.gradient.magenta": "Пурпуровый ґрадіент",
  "block.minecraft.banner.gradient.orange": "Оранджовый ґрадіент",
  "block.minecraft.banner.gradient.pink": "Ружовый ґрадіент",
  "block.minecraft.banner.gradient.purple": "Ліловый ґрадіент",
  "block.minecraft.banner.gradient.red": "Черленый ґрадіент",
  "block.minecraft.banner.gradient.white": "Білый ґрадіент",
  "block.minecraft.banner.gradient.yellow": "Жовтый ґрадіент",
  "block.minecraft.banner.gradient_up.black": "Чорный ґрадіент здолув",
  "block.minecraft.banner.gradient_up.blue": "Синьый ґрадіент здолув",
  "block.minecraft.banner.gradient_up.brown": "Барнастый ґрадіент здолув",
  "block.minecraft.banner.gradient_up.cyan": "Ціановый ґрадіент здолув",
  "block.minecraft.banner.gradient_up.gray": "Сірый ґрадіент здолув",
  "block.minecraft.banner.gradient_up.green": "Зеленый ґрадіент здолув",
  "block.minecraft.banner.gradient_up.light_blue": "Голубый ґрадіент здолув",
  "block.minecraft.banner.gradient_up.light_gray": "Світлосірый ґрадіент здолув",
  "block.minecraft.banner.gradient_up.lime": "Лаймовый ґрадіент здолув",
  "block.minecraft.banner.gradient_up.magenta": "Пурпуровый ґрадіент здолув",
  "block.minecraft.banner.gradient_up.orange": "Оранджовый ґрадіент здолув",
  "block.minecraft.banner.gradient_up.pink": "Ружовый ґрадіент здолув",
  "block.minecraft.banner.gradient_up.purple": "Ліловый ґрадіент здолув",
  "block.minecraft.banner.gradient_up.red": "Черленый ґрадіент здолув",
  "block.minecraft.banner.gradient_up.white": "Білый ґрадіент здолув",
  "block.minecraft.banner.gradient_up.yellow": "Жовтый ґрадіент здолув",
  "block.minecraft.banner.guster.black": "Чорный подув",
  "block.minecraft.banner.guster.blue": "Синьый подув",
  "block.minecraft.banner.guster.brown": "Барнастый подув",
  "block.minecraft.banner.guster.cyan": "Ціановый подув",
  "block.minecraft.banner.guster.gray": "Сірый подув",
  "block.minecraft.banner.guster.green": "Зеленый подув",
  "block.minecraft.banner.guster.light_blue": "Голубый подув",
  "block.minecraft.banner.guster.light_gray": "Світлосірый подув",
  "block.minecraft.banner.guster.lime": "Лаймовый подув",
  "block.minecraft.banner.guster.magenta": "Пурпуровый подув",
  "block.minecraft.banner.guster.orange": "Оранджовый подув",
  "block.minecraft.banner.guster.pink": "Ружовый подув",
  "block.minecraft.banner.guster.purple": "Ліловый подув",
  "block.minecraft.banner.guster.red": "Черленый подув",
  "block.minecraft.banner.guster.white": "Білый подув",
  "block.minecraft.banner.guster.yellow": "Жовтый подув",
  "block.minecraft.banner.half_horizontal.black": "Чорна вирьхня половина",
  "block.minecraft.banner.half_horizontal.blue": "Синя вирьхня половина",
  "block.minecraft.banner.half_horizontal.brown": "Барнаста вирьхня половина",
  "block.minecraft.banner.half_horizontal.cyan": "Ціанова вирьхня половина",
  "block.minecraft.banner.half_horizontal.gray": "Сіра вирьхня половина",
  "block.minecraft.banner.half_horizontal.green": "Зелена вирьхня половина",
  "block.minecraft.banner.half_horizontal.light_blue": "Голуба вирьхня половина",
  "block.minecraft.banner.half_horizontal.light_gray": "Світлосіра вирьхня половина",
  "block.minecraft.banner.half_horizontal.lime": "Лаймова вирьхня половина",
  "block.minecraft.banner.half_horizontal.magenta": "Пурпурова вирьхня половина",
  "block.minecraft.banner.half_horizontal.orange": "Оранджова вирьхня половина",
  "block.minecraft.banner.half_horizontal.pink": "Ружова вирьхня половина",
  "block.minecraft.banner.half_horizontal.purple": "Лілова вирьхня половина",
  "block.minecraft.banner.half_horizontal.red": "Черлена вирьхня половина",
  "block.minecraft.banner.half_horizontal.white": "Біла вирьхня половина",
  "block.minecraft.banner.half_horizontal.yellow": "Жовта вирьхня половина",
  "block.minecraft.banner.half_horizontal_bottom.black": "Чорна нижня половина",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Синя нижня половина",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Барнаста нижня половина",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Ціанова нижня половина",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Сіра нижня половина",
  "block.minecraft.banner.half_horizontal_bottom.green": "Зелена нижня половина",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Голуба нижня половина",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Світлосіра нижня половина",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Лаймова нижня половина",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Пурпурова нижня половина",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Оранджова нижня половина",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Ружова нижня половина",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Лілова нижня половина",
  "block.minecraft.banner.half_horizontal_bottom.red": "Черлена нижня половина",
  "block.minecraft.banner.half_horizontal_bottom.white": "Біла нижня половина",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Жовта нижня половина",
  "block.minecraft.banner.half_vertical.black": "Чорна ліва половина",
  "block.minecraft.banner.half_vertical.blue": "Синя ліва половина",
  "block.minecraft.banner.half_vertical.brown": "Барнаста ліва половина",
  "block.minecraft.banner.half_vertical.cyan": "Ціанова ліва половина",
  "block.minecraft.banner.half_vertical.gray": "Сіра ліва половина",
  "block.minecraft.banner.half_vertical.green": "Зелена ліва половина",
  "block.minecraft.banner.half_vertical.light_blue": "Голуба ліва половина",
  "block.minecraft.banner.half_vertical.light_gray": "Світлосіра ліва половина",
  "block.minecraft.banner.half_vertical.lime": "Лаймова ліва половина",
  "block.minecraft.banner.half_vertical.magenta": "Пурпурова ліва половина",
  "block.minecraft.banner.half_vertical.orange": "Оранджова ліва половина",
  "block.minecraft.banner.half_vertical.pink": "Ружова ліва половина",
  "block.minecraft.banner.half_vertical.purple": "Лілова ліва половина",
  "block.minecraft.banner.half_vertical.red": "Черлена ліва половина",
  "block.minecraft.banner.half_vertical.white": "Біла ліва половина",
  "block.minecraft.banner.half_vertical.yellow": "Жовта ліва половина",
  "block.minecraft.banner.half_vertical_right.black": "Чорна права половина",
  "block.minecraft.banner.half_vertical_right.blue": "Синя права половина",
  "block.minecraft.banner.half_vertical_right.brown": "Барнаста права половина",
  "block.minecraft.banner.half_vertical_right.cyan": "Ціанова права половина",
  "block.minecraft.banner.half_vertical_right.gray": "Сіра права половина",
  "block.minecraft.banner.half_vertical_right.green": "Зелена права половина",
  "block.minecraft.banner.half_vertical_right.light_blue": "Голуба нижня половина",
  "block.minecraft.banner.half_vertical_right.light_gray": "Світлосіра нижня половина",
  "block.minecraft.banner.half_vertical_right.lime": "Лаймова права половина",
  "block.minecraft.banner.half_vertical_right.magenta": "Пурпурова права половина",
  "block.minecraft.banner.half_vertical_right.orange": "Оранджова права половина",
  "block.minecraft.banner.half_vertical_right.pink": "Ружова права половина",
  "block.minecraft.banner.half_vertical_right.purple": "Ружова права половина",
  "block.minecraft.banner.half_vertical_right.red": "Черлена права половина",
  "block.minecraft.banner.half_vertical_right.white": "Біла права половина",
  "block.minecraft.banner.half_vertical_right.yellow": "Жовта права половина",
  "block.minecraft.banner.mojang.black": "Чорноє дашто",
  "block.minecraft.banner.mojang.blue": "Синёє дашто",
  "block.minecraft.banner.mojang.brown": "Барнастоє дашто",
  "block.minecraft.banner.mojang.cyan": "Ціановоє дашто",
  "block.minecraft.banner.mojang.gray": "Сіроє дашто",
  "block.minecraft.banner.mojang.green": "Зеленоє дашто",
  "block.minecraft.banner.mojang.light_blue": "Голубый предмет",
  "block.minecraft.banner.mojang.light_gray": "Світлосіроє дашто",
  "block.minecraft.banner.mojang.lime": "Лаймовоє дашто",
  "block.minecraft.banner.mojang.magenta": "Пурпуровоє дашто",
  "block.minecraft.banner.mojang.orange": "Оранджовоє дашто",
  "block.minecraft.banner.mojang.pink": "Ружовоє дашто",
  "block.minecraft.banner.mojang.purple": "Ліловоє дашто",
  "block.minecraft.banner.mojang.red": "Черленоє дашто",
  "block.minecraft.banner.mojang.white": "Білый предмет",
  "block.minecraft.banner.mojang.yellow": "Жовтоє дашто",
  "block.minecraft.banner.piglin.black": "Чорна фаца",
  "block.minecraft.banner.piglin.blue": "Синя фаца",
  "block.minecraft.banner.piglin.brown": "Барнаста фаца",
  "block.minecraft.banner.piglin.cyan": "Ціанова фаца",
  "block.minecraft.banner.piglin.gray": "Сіра фаца",
  "block.minecraft.banner.piglin.green": "Зелена фаца",
  "block.minecraft.banner.piglin.light_blue": "Голуба фаца",
  "block.minecraft.banner.piglin.light_gray": "Світлосіра фаца",
  "block.minecraft.banner.piglin.lime": "Лаймова фаца",
  "block.minecraft.banner.piglin.magenta": "Пурпурова фаца",
  "block.minecraft.banner.piglin.orange": "Оранджова фаца",
  "block.minecraft.banner.piglin.pink": "Ружова фаца",
  "block.minecraft.banner.piglin.purple": "Лілова фаца",
  "block.minecraft.banner.piglin.red": "Черлена фаца",
  "block.minecraft.banner.piglin.white": "Біла фаца",
  "block.minecraft.banner.piglin.yellow": "Жовта фаца",
  "block.minecraft.banner.rhombus.black": "Чорный ромб",
  "block.minecraft.banner.rhombus.blue": "Синьый ромб",
  "block.minecraft.banner.rhombus.brown": "Барнастый ромб",
  "block.minecraft.banner.rhombus.cyan": "Ціановый ромб",
  "block.minecraft.banner.rhombus.gray": "Сірый ромб",
  "block.minecraft.banner.rhombus.green": "Зеленый ромб",
  "block.minecraft.banner.rhombus.light_blue": "Голубый ромб",
  "block.minecraft.banner.rhombus.light_gray": "Світлосірый ромб",
  "block.minecraft.banner.rhombus.lime": "Лаймовый ромб",
  "block.minecraft.banner.rhombus.magenta": "Пурпуровый ромб",
  "block.minecraft.banner.rhombus.orange": "Оранджовый ромб",
  "block.minecraft.banner.rhombus.pink": "Ружовый ромб",
  "block.minecraft.banner.rhombus.purple": "Ліловый ромб",
  "block.minecraft.banner.rhombus.red": "Черленый ромб",
  "block.minecraft.banner.rhombus.white": "Білый ромб",
  "block.minecraft.banner.rhombus.yellow": "Жовтый ромб",
  "block.minecraft.banner.skull.black": "Чорна значка копоні",
  "block.minecraft.banner.skull.blue": "Синя значка копоні",
  "block.minecraft.banner.skull.brown": "Барнаста значка копоні",
  "block.minecraft.banner.skull.cyan": "Ціанова значка копоні",
  "block.minecraft.banner.skull.gray": "Сіра значка копоні",
  "block.minecraft.banner.skull.green": "Зелена значка копоні",
  "block.minecraft.banner.skull.light_blue": "Голуба значка копоні",
  "block.minecraft.banner.skull.light_gray": "Світлосіра значка копоні",
  "block.minecraft.banner.skull.lime": "Лаймова значка копоні",
  "block.minecraft.banner.skull.magenta": "Пурпурова значка копоні",
  "block.minecraft.banner.skull.orange": "Оранджова значка копоні",
  "block.minecraft.banner.skull.pink": "Ружова значка копоні",
  "block.minecraft.banner.skull.purple": "Лілова значка копоні",
  "block.minecraft.banner.skull.red": "Черлена значка копоні",
  "block.minecraft.banner.skull.white": "Біла значка копоні",
  "block.minecraft.banner.skull.yellow": "Жовта значка копоні",
  "block.minecraft.banner.small_stripes.black": "Чорні стовпы",
  "block.minecraft.banner.small_stripes.blue": "Сині стовпы",
  "block.minecraft.banner.small_stripes.brown": "Барнасті стовпы",
  "block.minecraft.banner.small_stripes.cyan": "Ціанові стовпы",
  "block.minecraft.banner.small_stripes.gray": "Сірі стовпы",
  "block.minecraft.banner.small_stripes.green": "Зелені стовпы",
  "block.minecraft.banner.small_stripes.light_blue": "Голубі стовпы",
  "block.minecraft.banner.small_stripes.light_gray": "Світлосірі стовпы",
  "block.minecraft.banner.small_stripes.lime": "Лаймові стовпы",
  "block.minecraft.banner.small_stripes.magenta": "Пурпурові стовпы",
  "block.minecraft.banner.small_stripes.orange": "Оранджові стовпы",
  "block.minecraft.banner.small_stripes.pink": "Ружові стовпы",
  "block.minecraft.banner.small_stripes.purple": "Лілові стовпы",
  "block.minecraft.banner.small_stripes.red": "Черлені стовпы",
  "block.minecraft.banner.small_stripes.white": "Білі стовпы",
  "block.minecraft.banner.small_stripes.yellow": "Жовті стовпы",
  "block.minecraft.banner.square_bottom_left.black": "Чорный нижньый правый квадрат",
  "block.minecraft.banner.square_bottom_left.blue": "Синьый нижньый правый квадрат",
  "block.minecraft.banner.square_bottom_left.brown": "Барнастый нижньый правый квадрат",
  "block.minecraft.banner.square_bottom_left.cyan": "Ціановый нижньый правый квадрат",
  "block.minecraft.banner.square_bottom_left.gray": "Сірый нижньый правый квадрат",
  "block.minecraft.banner.square_bottom_left.green": "Зеленый нижньый правый квадрат",
  "block.minecraft.banner.square_bottom_left.light_blue": "Голубый нижньый правый квадрат",
  "block.minecraft.banner.square_bottom_left.light_gray": "Світлосірый нижньый правый квадрат",
  "block.minecraft.banner.square_bottom_left.lime": "Лаймовый нижньый правый квадрат",
  "block.minecraft.banner.square_bottom_left.magenta": "Пурпуровый нижньый правый квадрат",
  "block.minecraft.banner.square_bottom_left.orange": "Оранджовый нижньый правый квадрат",
  "block.minecraft.banner.square_bottom_left.pink": "Ружовый нижньый правый квадрат",
  "block.minecraft.banner.square_bottom_left.purple": "Ліловый нижньый правый квадрат",
  "block.minecraft.banner.square_bottom_left.red": "Черленый нижньый правый квадрат",
  "block.minecraft.banner.square_bottom_left.white": "Білый нижньый правый квадрат",
  "block.minecraft.banner.square_bottom_left.yellow": "Жовтый нижньый правый квадрат",
  "block.minecraft.banner.square_bottom_right.black": "Чорный нижньый лівый квадрат",
  "block.minecraft.banner.square_bottom_right.blue": "Синьый нижньый лівый квадрат",
  "block.minecraft.banner.square_bottom_right.brown": "Барнастый нижньый лівый квадрат",
  "block.minecraft.banner.square_bottom_right.cyan": "Ціановый нижньый лівый квадрат",
  "block.minecraft.banner.square_bottom_right.gray": "Сірый нижньый лівый квадрат",
  "block.minecraft.banner.square_bottom_right.green": "Зеленый нижньый лівый квадрат",
  "block.minecraft.banner.square_bottom_right.light_blue": "Голубый нижньый лівый квадрат",
  "block.minecraft.banner.square_bottom_right.light_gray": "Світлосірый нижньый лівый квадрат",
  "block.minecraft.banner.square_bottom_right.lime": "Лаймовый нижньый лівый квадрат",
  "block.minecraft.banner.square_bottom_right.magenta": "Пурпуровый нижньый лівый квадрат",
  "block.minecraft.banner.square_bottom_right.orange": "Оранджовый нижньый лівый квадрат",
  "block.minecraft.banner.square_bottom_right.pink": "Ружовый нижньый лівый квадрат",
  "block.minecraft.banner.square_bottom_right.purple": "Ліловый нижньый лівый квадрат",
  "block.minecraft.banner.square_bottom_right.red": "Черленый нижньый лівый квадрат",
  "block.minecraft.banner.square_bottom_right.white": "Білый нижньый лівый квадрат",
  "block.minecraft.banner.square_bottom_right.yellow": "Жовтый нижньый лівый квадрат",
  "block.minecraft.banner.square_top_left.black": "Чорный вирьхньый правый квадрат",
  "block.minecraft.banner.square_top_left.blue": "Синьый вирьхньый правый квадрат",
  "block.minecraft.banner.square_top_left.brown": "Барнастый вирьхньый правый квадрат",
  "block.minecraft.banner.square_top_left.cyan": "Ціановый вирьхньый правый квадрат",
  "block.minecraft.banner.square_top_left.gray": "Сірый вирьхньый правый квадрат",
  "block.minecraft.banner.square_top_left.green": "Зеленый вирьхньый правый квадрат",
  "block.minecraft.banner.square_top_left.light_blue": "Голубый вирьхньый правый квадрат",
  "block.minecraft.banner.square_top_left.light_gray": "Світлосірый вирьхньый правый квадрат",
  "block.minecraft.banner.square_top_left.lime": "Лаймовый вирьхньый правый квадрат",
  "block.minecraft.banner.square_top_left.magenta": "Пурпуровый вирьхньый правый квадрат",
  "block.minecraft.banner.square_top_left.orange": "Оранджовый вирьхньый правый квадрат",
  "block.minecraft.banner.square_top_left.pink": "Ружовый вирьхньый правый квадрат",
  "block.minecraft.banner.square_top_left.purple": "Ліловый вирьхньый правый квадрат",
  "block.minecraft.banner.square_top_left.red": "Черленый вирьхньый правый квадрат",
  "block.minecraft.banner.square_top_left.white": "Білый вирьхньый правый квадрат",
  "block.minecraft.banner.square_top_left.yellow": "Жовтый вирьхньый правый квадрат",
  "block.minecraft.banner.square_top_right.black": "Чорный вирьхньый лівый квадрат",
  "block.minecraft.banner.square_top_right.blue": "Синьый вирьхньый лівый квадрат",
  "block.minecraft.banner.square_top_right.brown": "Барнастый вирьхньый лівый квадрат",
  "block.minecraft.banner.square_top_right.cyan": "Ціановый вирьхньый лівый квадрат",
  "block.minecraft.banner.square_top_right.gray": "Сірый вирьхньый лівый квадрат",
  "block.minecraft.banner.square_top_right.green": "Зеленый вирьхньый лівый квадрат",
  "block.minecraft.banner.square_top_right.light_blue": "Голубый вирьхньый лівый квадрат",
  "block.minecraft.banner.square_top_right.light_gray": "Світлосірый вирьхньый лівый квадрат",
  "block.minecraft.banner.square_top_right.lime": "Лаймовый вирьхньый лівый квадрат",
  "block.minecraft.banner.square_top_right.magenta": "Пурпуровый вирьхньый лівый квадрат",
  "block.minecraft.banner.square_top_right.orange": "Оранджовый вирьхньый лівый квадрат",
  "block.minecraft.banner.square_top_right.pink": "Ружовый вирьхньый лівый квадрат",
  "block.minecraft.banner.square_top_right.purple": "Ліловый вирьхньый лівый квадрат",
  "block.minecraft.banner.square_top_right.red": "Черленый вирьхньый лівый квадрат",
  "block.minecraft.banner.square_top_right.white": "Білый вирьхньый лівый квадрат",
  "block.minecraft.banner.square_top_right.yellow": "Жовтый вирьхньый лівый квадрат",
  "block.minecraft.banner.straight_cross.black": "Чорный хрест",
  "block.minecraft.banner.straight_cross.blue": "Синьый хрест",
  "block.minecraft.banner.straight_cross.brown": "Барнастый хрест",
  "block.minecraft.banner.straight_cross.cyan": "Ціановый хрест",
  "block.minecraft.banner.straight_cross.gray": "Сірый хрест",
  "block.minecraft.banner.straight_cross.green": "Зеленый хрест",
  "block.minecraft.banner.straight_cross.light_blue": "Голубый хрест",
  "block.minecraft.banner.straight_cross.light_gray": "Світлосірый хрест",
  "block.minecraft.banner.straight_cross.lime": "Лаймовый хрест",
  "block.minecraft.banner.straight_cross.magenta": "Пурпуровый хрест",
  "block.minecraft.banner.straight_cross.orange": "Оранджовый хрест",
  "block.minecraft.banner.straight_cross.pink": "Ружовый хрест",
  "block.minecraft.banner.straight_cross.purple": "Ліловый хрест",
  "block.minecraft.banner.straight_cross.red": "Черленый хрест",
  "block.minecraft.banner.straight_cross.white": "Білый хрест",
  "block.minecraft.banner.straight_cross.yellow": "Жовтый хрест",
  "block.minecraft.banner.stripe_bottom.black": "Чорноє основаня",
  "block.minecraft.banner.stripe_bottom.blue": "Синёє основаня",
  "block.minecraft.banner.stripe_bottom.brown": "Барнастоє основаня",
  "block.minecraft.banner.stripe_bottom.cyan": "Ціановоє основаня",
  "block.minecraft.banner.stripe_bottom.gray": "Сіроє основаня",
  "block.minecraft.banner.stripe_bottom.green": "Зеленоє основаня",
  "block.minecraft.banner.stripe_bottom.light_blue": "Голубоє основаня",
  "block.minecraft.banner.stripe_bottom.light_gray": "Світлосіроє основаня",
  "block.minecraft.banner.stripe_bottom.lime": "Лаймовоє основаня",
  "block.minecraft.banner.stripe_bottom.magenta": "Пурпуровоє основаня",
  "block.minecraft.banner.stripe_bottom.orange": "Оранджовоє основаня",
  "block.minecraft.banner.stripe_bottom.pink": "Ружовоє основаня",
  "block.minecraft.banner.stripe_bottom.purple": "Ліловоє основаня",
  "block.minecraft.banner.stripe_bottom.red": "Черленоє основаня",
  "block.minecraft.banner.stripe_bottom.white": "Білоє основаня",
  "block.minecraft.banner.stripe_bottom.yellow": "Жовтоє основаня",
  "block.minecraft.banner.stripe_center.black": "Чорный стовп",
  "block.minecraft.banner.stripe_center.blue": "Синьый стовп",
  "block.minecraft.banner.stripe_center.brown": "Барнастый стовп",
  "block.minecraft.banner.stripe_center.cyan": "Ціановый стовп",
  "block.minecraft.banner.stripe_center.gray": "Сірый стовп",
  "block.minecraft.banner.stripe_center.green": "Зеленый стовп",
  "block.minecraft.banner.stripe_center.light_blue": "Голубый стовп",
  "block.minecraft.banner.stripe_center.light_gray": "Світлосірый стовп",
  "block.minecraft.banner.stripe_center.lime": "Лаймовый стовп",
  "block.minecraft.banner.stripe_center.magenta": "Пурпуровый стовп",
  "block.minecraft.banner.stripe_center.orange": "Оранджовый стовп",
  "block.minecraft.banner.stripe_center.pink": "Ружовый стовп",
  "block.minecraft.banner.stripe_center.purple": "Ліловый стовп",
  "block.minecraft.banner.stripe_center.red": "Черленый стовп",
  "block.minecraft.banner.stripe_center.white": "Білый стовп",
  "block.minecraft.banner.stripe_center.yellow": "Жовтый стовп",
  "block.minecraft.banner.stripe_downleft.black": "Чорна нижня ліва лінія",
  "block.minecraft.banner.stripe_downleft.blue": "Синя нижня ліва лінія",
  "block.minecraft.banner.stripe_downleft.brown": "Барнаста нижня ліва лінія",
  "block.minecraft.banner.stripe_downleft.cyan": "Ціанова нижня ліва лінія",
  "block.minecraft.banner.stripe_downleft.gray": "Сіра нижня ліва лінія",
  "block.minecraft.banner.stripe_downleft.green": "Зелена нижня ліва лінія",
  "block.minecraft.banner.stripe_downleft.light_blue": "Голуба ліва нижня лінія",
  "block.minecraft.banner.stripe_downleft.light_gray": "Світлосіра ліва нижня лінія",
  "block.minecraft.banner.stripe_downleft.lime": "Лаймова нижня ліва лінія",
  "block.minecraft.banner.stripe_downleft.magenta": "Пурпурова нижня ліва лінія",
  "block.minecraft.banner.stripe_downleft.orange": "Оранджова нижня ліва лінія",
  "block.minecraft.banner.stripe_downleft.pink": "Ружова нижня ліва лінія",
  "block.minecraft.banner.stripe_downleft.purple": "Лілова нижня ліва лінія",
  "block.minecraft.banner.stripe_downleft.red": "Черлена нижня ліва лінія",
  "block.minecraft.banner.stripe_downleft.white": "Біла нижня ліва лінія",
  "block.minecraft.banner.stripe_downleft.yellow": "Жовта нижня ліва лінія",
  "block.minecraft.banner.stripe_downright.black": "Чорна нижня права лінія",
  "block.minecraft.banner.stripe_downright.blue": "Синя нижня права лінія",
  "block.minecraft.banner.stripe_downright.brown": "Барнаста нижня права лінія",
  "block.minecraft.banner.stripe_downright.cyan": "Ціанова нижня права лінія",
  "block.minecraft.banner.stripe_downright.gray": "Сіра нижня права лінія",
  "block.minecraft.banner.stripe_downright.green": "Зелена нижня права лінія",
  "block.minecraft.banner.stripe_downright.light_blue": "Голуба нижня права лінія",
  "block.minecraft.banner.stripe_downright.light_gray": "Світлосіра нижня права лінія",
  "block.minecraft.banner.stripe_downright.lime": "Лаймова нижня права лінія",
  "block.minecraft.banner.stripe_downright.magenta": "Пурпурова нижня права лінія",
  "block.minecraft.banner.stripe_downright.orange": "Оранджова нижня права лінія",
  "block.minecraft.banner.stripe_downright.pink": "Ружова нижня права лінія",
  "block.minecraft.banner.stripe_downright.purple": "Лілова нижня права лінія",
  "block.minecraft.banner.stripe_downright.red": "Черлена нижня права лінія",
  "block.minecraft.banner.stripe_downright.white": "Біла нижня права лінія",
  "block.minecraft.banner.stripe_downright.yellow": "Жовта нижня права лінія",
  "block.minecraft.banner.stripe_left.black": "Чорноє пасмо зліва",
  "block.minecraft.banner.stripe_left.blue": "Синёє пасмо зліва",
  "block.minecraft.banner.stripe_left.brown": "Барнастоє пасмо зліва",
  "block.minecraft.banner.stripe_left.cyan": "Ціановоє пасмо зліва",
  "block.minecraft.banner.stripe_left.gray": "Сіроє пасмо зліва",
  "block.minecraft.banner.stripe_left.green": "Зеленоє пасмо зліва",
  "block.minecraft.banner.stripe_left.light_blue": "Голубоє пасмо зліва",
  "block.minecraft.banner.stripe_left.light_gray": "Світлосіроє пасмо зліва",
  "block.minecraft.banner.stripe_left.lime": "Лаймовоє пасмо зліва",
  "block.minecraft.banner.stripe_left.magenta": "Пурпуровоє пасмо зліва",
  "block.minecraft.banner.stripe_left.orange": "Оранджовоє пасмо зліва",
  "block.minecraft.banner.stripe_left.pink": "Ружовоє пасмо зліва",
  "block.minecraft.banner.stripe_left.purple": "Ліловоє пасмо зліва",
  "block.minecraft.banner.stripe_left.red": "Черленоє пасмо зліва",
  "block.minecraft.banner.stripe_left.white": "Білоє пасмо зліва",
  "block.minecraft.banner.stripe_left.yellow": "Жовтоє пасмо зліва",
  "block.minecraft.banner.stripe_middle.black": "Чорный пояс",
  "block.minecraft.banner.stripe_middle.blue": "Синьый пояс",
  "block.minecraft.banner.stripe_middle.brown": "Барнастый пояс",
  "block.minecraft.banner.stripe_middle.cyan": "Ціановый пояс",
  "block.minecraft.banner.stripe_middle.gray": "Сірый пояс",
  "block.minecraft.banner.stripe_middle.green": "Зеленый пояс",
  "block.minecraft.banner.stripe_middle.light_blue": "Голубый  пояс",
  "block.minecraft.banner.stripe_middle.light_gray": "Світлосірый пояс",
  "block.minecraft.banner.stripe_middle.lime": "Лаймовый пояс",
  "block.minecraft.banner.stripe_middle.magenta": "Пурпуровый пояс",
  "block.minecraft.banner.stripe_middle.orange": "Оранджовый пояс",
  "block.minecraft.banner.stripe_middle.pink": "Ружовый пояс",
  "block.minecraft.banner.stripe_middle.purple": "Ліловый пояс",
  "block.minecraft.banner.stripe_middle.red": "Черленый пояс",
  "block.minecraft.banner.stripe_middle.white": "Білый пояс",
  "block.minecraft.banner.stripe_middle.yellow": "Жовтый пояс",
  "block.minecraft.banner.stripe_right.black": "Чорноє пасмо зправа",
  "block.minecraft.banner.stripe_right.blue": "Синёє пасмо зправа",
  "block.minecraft.banner.stripe_right.brown": "Барнастоє пасмо зправа",
  "block.minecraft.banner.stripe_right.cyan": "Ціановоє пасмо зправа",
  "block.minecraft.banner.stripe_right.gray": "Сіроє пасмо зправа",
  "block.minecraft.banner.stripe_right.green": "Зеленоє пасмо зправа",
  "block.minecraft.banner.stripe_right.light_blue": "Голубоє пасмо зправа",
  "block.minecraft.banner.stripe_right.light_gray": "Світлосіроє пасмо зправа",
  "block.minecraft.banner.stripe_right.lime": "Лаймовоє пасмо зправа",
  "block.minecraft.banner.stripe_right.magenta": "Пурпуровоє пасмо зправа",
  "block.minecraft.banner.stripe_right.orange": "Оранджовоє пасмо зправа",
  "block.minecraft.banner.stripe_right.pink": "Ружовоє пасмо зправа",
  "block.minecraft.banner.stripe_right.purple": "Ліловоє пасмо зправа",
  "block.minecraft.banner.stripe_right.red": "Черленоє пасмо зправа",
  "block.minecraft.banner.stripe_right.white": "Білоє пасмо зправа",
  "block.minecraft.banner.stripe_right.yellow": "Жовтоє пасмо зправа",
  "block.minecraft.banner.stripe_top.black": "Чорный вирьх",
  "block.minecraft.banner.stripe_top.blue": "Синьый вирьх",
  "block.minecraft.banner.stripe_top.brown": "Барнастый вирьх",
  "block.minecraft.banner.stripe_top.cyan": "Ціановый вирьх",
  "block.minecraft.banner.stripe_top.gray": "Сірый вирьх",
  "block.minecraft.banner.stripe_top.green": "Зеленый вирьх",
  "block.minecraft.banner.stripe_top.light_blue": "Голубый  вирьх",
  "block.minecraft.banner.stripe_top.light_gray": "Світлосірый вирьх",
  "block.minecraft.banner.stripe_top.lime": "Лаймовый вирьх",
  "block.minecraft.banner.stripe_top.magenta": "Пурпуровый вирьх",
  "block.minecraft.banner.stripe_top.orange": "Оранджовый вирьх",
  "block.minecraft.banner.stripe_top.pink": "Ружовый вирьх",
  "block.minecraft.banner.stripe_top.purple": "Ліловый вирьх",
  "block.minecraft.banner.stripe_top.red": "Черленый вирьх",
  "block.minecraft.banner.stripe_top.white": "Білый вирьх",
  "block.minecraft.banner.stripe_top.yellow": "Жовтый вирьх",
  "block.minecraft.banner.triangle_bottom.black": "Чорный нижньый трикутник",
  "block.minecraft.banner.triangle_bottom.blue": "Синьый нижньый трикутник",
  "block.minecraft.banner.triangle_bottom.brown": "Барнастый нижньый трикутник",
  "block.minecraft.banner.triangle_bottom.cyan": "Ціановый нижньый трикутник",
  "block.minecraft.banner.triangle_bottom.gray": "Сірый нижньый трикутник",
  "block.minecraft.banner.triangle_bottom.green": "Зеленый нижньый трикутник",
  "block.minecraft.banner.triangle_bottom.light_blue": "Голубый нижньый трикутник",
  "block.minecraft.banner.triangle_bottom.light_gray": "Світлосірый нижньый трикутник",
  "block.minecraft.banner.triangle_bottom.lime": "Лаймовый нижньый трикутник",
  "block.minecraft.banner.triangle_bottom.magenta": "Пурпуровый нижньый трикутник",
  "block.minecraft.banner.triangle_bottom.orange": "Оранджовый нижньый трикутник",
  "block.minecraft.banner.triangle_bottom.pink": "Ружовый нижньый трикутник",
  "block.minecraft.banner.triangle_bottom.purple": "Ліловый нижньый трикутник",
  "block.minecraft.banner.triangle_bottom.red": "Черленый нижньый трикутник",
  "block.minecraft.banner.triangle_bottom.white": "Білый нижньый трикутник",
  "block.minecraft.banner.triangle_bottom.yellow": "Жовтый нижньый трикутник",
  "block.minecraft.banner.triangle_top.black": "Чорный вирьхньый трикутник",
  "block.minecraft.banner.triangle_top.blue": "Синьый вирьхньый трикутник",
  "block.minecraft.banner.triangle_top.brown": "Барнастый вирьхньый трикутник",
  "block.minecraft.banner.triangle_top.cyan": "Ціановый вирьхньый трикутник",
  "block.minecraft.banner.triangle_top.gray": "Сірый вирьхньый трикутник",
  "block.minecraft.banner.triangle_top.green": "Зеленый вирьхньый трикутник",
  "block.minecraft.banner.triangle_top.light_blue": "Голубый вирьхньый трикутник",
  "block.minecraft.banner.triangle_top.light_gray": "Світлосірый вирьхньый трикутник",
  "block.minecraft.banner.triangle_top.lime": "Лаймовый вирьхньый трикутник",
  "block.minecraft.banner.triangle_top.magenta": "Пурпуровый вирьхньый трикутник",
  "block.minecraft.banner.triangle_top.orange": "Оранджовый вирьхньый трикутник",
  "block.minecraft.banner.triangle_top.pink": "Ружовый вирьхньый трикутник",
  "block.minecraft.banner.triangle_top.purple": "Ліловый вирьхньый трикутник",
  "block.minecraft.banner.triangle_top.red": "Черленый вирьхньый трикутник",
  "block.minecraft.banner.triangle_top.white": "Білый вирьхньый трикутник",
  "block.minecraft.banner.triangle_top.yellow": "Жовтый вирьхньый трикутник",
  "block.minecraft.banner.triangles_bottom.black": "Чорна нижня лінія из удступом",
  "block.minecraft.banner.triangles_bottom.blue": "Синя нижня лінія из удступом",
  "block.minecraft.banner.triangles_bottom.brown": "Барнаста нижня лінія из удступом",
  "block.minecraft.banner.triangles_bottom.cyan": "Ціанова нижня лінія из удступом",
  "block.minecraft.banner.triangles_bottom.gray": "Сіра нижня лінія из удступом",
  "block.minecraft.banner.triangles_bottom.green": "Зелена нижня лінія из удступом",
  "block.minecraft.banner.triangles_bottom.light_blue": "Голуба нижня лінія из удступом",
  "block.minecraft.banner.triangles_bottom.light_gray": "Світлосіра нижня лінія из удступом",
  "block.minecraft.banner.triangles_bottom.lime": "Лаймова нижня лінія из удступом",
  "block.minecraft.banner.triangles_bottom.magenta": "Пурпурова нижня лінія из удступом",
  "block.minecraft.banner.triangles_bottom.orange": "Оранджова нижня лінія из удступом",
  "block.minecraft.banner.triangles_bottom.pink": "Ружова нижня лінія из удступом",
  "block.minecraft.banner.triangles_bottom.purple": "Лілова нижня лінія из удступом",
  "block.minecraft.banner.triangles_bottom.red": "Черлена нижня лінія из удступом",
  "block.minecraft.banner.triangles_bottom.white": "Біла нижня лінія из удступом",
  "block.minecraft.banner.triangles_bottom.yellow": "Жовта нижня лінія из удступом",
  "block.minecraft.banner.triangles_top.black": "Чорна вирьхня лінія из удступом",
  "block.minecraft.banner.triangles_top.blue": "Синя вирьхня лінія из удступом",
  "block.minecraft.banner.triangles_top.brown": "Барнаста вирьхня лінія из удступом",
  "block.minecraft.banner.triangles_top.cyan": "Ціанова вирьхня лінія из удступом",
  "block.minecraft.banner.triangles_top.gray": "Сіра вирьхня лінія из удступом",
  "block.minecraft.banner.triangles_top.green": "Зелена вирьхня лінія из удступом",
  "block.minecraft.banner.triangles_top.light_blue": "Світлосіра вирьхня лінія из удступом",
  "block.minecraft.banner.triangles_top.light_gray": "Голуба вирьхня лінія из удступом",
  "block.minecraft.banner.triangles_top.lime": "Лаймова вирьхня лінія из удступом",
  "block.minecraft.banner.triangles_top.magenta": "Пурпурова вирьхня лінія из удступом",
  "block.minecraft.banner.triangles_top.orange": "Оранджова вирьхня лінія из удступом",
  "block.minecraft.banner.triangles_top.pink": "Ружова вирьхня лінія из удступом",
  "block.minecraft.banner.triangles_top.purple": "Лілова вирьхня лінія из удступом",
  "block.minecraft.banner.triangles_top.red": "Черлена вирьхня лінія из удступом",
  "block.minecraft.banner.triangles_top.white": "Біла вирьхня лінія из удступом",
  "block.minecraft.banner.triangles_top.yellow": "Жовта вирьхня лінія из удступом",
  "block.minecraft.barrel": "Бодня",
  "block.minecraft.barrier": "Барьєра",
  "block.minecraft.basalt": "Базалт",
  "block.minecraft.beacon": "Маяк",
  "block.minecraft.beacon.primary": "Прімарна моца",
  "block.minecraft.beacon.secondary": "Секундарна моца",
  "block.minecraft.bed.no_sleep": "Спати мож лем через нуч авадь у бурю",
  "block.minecraft.bed.not_safe": "Не годни сьте си лячи, поблизь суть монстры",
  "block.minecraft.bed.obstructed": "Ися постиль є заблокована",
  "block.minecraft.bed.occupied": "Ися постиль є занята",
  "block.minecraft.bed.too_far_away": "Не годни сьте си лячи, постиль є дуже далеко",
  "block.minecraft.bedrock": "Бедрок",
  "block.minecraft.bee_nest": "Пчолиноє гніздо",
  "block.minecraft.beehive": "Пчолиный кымак",
  "block.minecraft.beetroots": "Бурак",
  "block.minecraft.bell": "Звун",
  "block.minecraft.big_dripleaf": "Великоє капкадло",
  "block.minecraft.big_dripleaf_stem": "Натина великого капкадла",
  "block.minecraft.birch_button": "Березовый ґомбик",
  "block.minecraft.birch_door": "Березові двирі",
  "block.minecraft.birch_fence": "Березовый плут",
  "block.minecraft.birch_fence_gate": "Березова капура",
  "block.minecraft.birch_hanging_sign": "Березова увіска",
  "block.minecraft.birch_leaves": "Березовоє листя",
  "block.minecraft.birch_log": "Березовый кымак",
  "block.minecraft.birch_planks": "Березові дощкы",
  "block.minecraft.birch_pressure_plate": "Березова ступова пластина",
  "block.minecraft.birch_sapling": "Скіпиць березы",
  "block.minecraft.birch_shelf": "Березова полиця",
  "block.minecraft.birch_sign": "Березова табличка",
  "block.minecraft.birch_slab": "Березова плита",
  "block.minecraft.birch_stairs": "Березові ґарадічі",
  "block.minecraft.birch_trapdoor": "Березовый пролаз",
  "block.minecraft.birch_wall_hanging_sign": "Березова стінна увіска",
  "block.minecraft.birch_wall_sign": "Березова стінна табличка",
  "block.minecraft.birch_wood": "Березовоє дерево",
  "block.minecraft.black_banner": "Чорна фана",
  "block.minecraft.black_bed": "Чорна постиль",
  "block.minecraft.black_candle": "Чорна свічка",
  "block.minecraft.black_candle_cake": "Торта из чорнов свічков",
  "block.minecraft.black_carpet": "Чорный покровиць",
  "block.minecraft.black_concrete": "Чорный бетон",
  "block.minecraft.black_concrete_powder": "Чорный цімент",
  "block.minecraft.black_glazed_terracotta": "Чорна поливана теракота",
  "block.minecraft.black_shulker_box": "Чорна шалкер-ладичка",
  "block.minecraft.black_stained_glass": "Чорноє скло",
  "block.minecraft.black_stained_glass_pane": "Чорноє вучко",
  "block.minecraft.black_terracotta": "Чорна теракота",
  "block.minecraft.black_wool": "Чорна вовна",
  "block.minecraft.blackstone": "Чорновчак",
  "block.minecraft.blackstone_slab": "Чорновчакова плита",
  "block.minecraft.blackstone_stairs": "Чорновчакові ґарадічі",
  "block.minecraft.blackstone_wall": "Чорновчаковый мур",
  "block.minecraft.blast_furnace": "Гамора",
  "block.minecraft.blue_banner": "Синя фана",
  "block.minecraft.blue_bed": "Синя постиль",
  "block.minecraft.blue_candle": "Синя свічка",
  "block.minecraft.blue_candle_cake": "Торта из синёв свічков",
  "block.minecraft.blue_carpet": "Синьый покровиць",
  "block.minecraft.blue_concrete": "Синьый бетон",
  "block.minecraft.blue_concrete_powder": "Синьый цімент",
  "block.minecraft.blue_glazed_terracotta": "Синя поливана теракота",
  "block.minecraft.blue_ice": "Синьый люд",
  "block.minecraft.blue_orchid": "Синя орхідея",
  "block.minecraft.blue_shulker_box": "Синя шалкер-ладичка",
  "block.minecraft.blue_stained_glass": "Синёє скло",
  "block.minecraft.blue_stained_glass_pane": "Синьоє вучко",
  "block.minecraft.blue_terracotta": "Синя теракота",
  "block.minecraft.blue_wool": "Синя вовна",
  "block.minecraft.bone_block": "Кустяный блок",
  "block.minecraft.bookshelf": "Книжный реґал",
  "block.minecraft.brain_coral": "Мозґовый корал",
  "block.minecraft.brain_coral_block": "Блок мозґового корала",
  "block.minecraft.brain_coral_fan": "Мозґовый корал-повівачка",
  "block.minecraft.brain_coral_wall_fan": "Горізонталный мозґовый корал-повівачка",
  "block.minecraft.brewing_stand": "Варилна пудставка",
  "block.minecraft.brick_slab": "Цигляна плита",
  "block.minecraft.brick_stairs": "Цигляні ґарадічі",
  "block.minecraft.brick_wall": "Цигляный мур",
  "block.minecraft.bricks": "Цигля",
  "block.minecraft.brown_banner": "Барнаста фана",
  "block.minecraft.brown_bed": "Барнаста постиль",
  "block.minecraft.brown_candle": "Барнаста свічка",
  "block.minecraft.brown_candle_cake": "Торта из барнастов свічков",
  "block.minecraft.brown_carpet": "Барнастый покровиць",
  "block.minecraft.brown_concrete": "Барнастый бетон",
  "block.minecraft.brown_concrete_powder": "Барнастый цімент",
  "block.minecraft.brown_glazed_terracotta": "Барнаста поливана теракота",
  "block.minecraft.brown_mushroom": "Барнастый гриб",
  "block.minecraft.brown_mushroom_block": "Блок барнастого гриба",
  "block.minecraft.brown_shulker_box": "Барнаста шалкер-ладичка",
  "block.minecraft.brown_stained_glass": "Барнастоє скло",
  "block.minecraft.brown_stained_glass_pane": "Барнастоє вучко",
  "block.minecraft.brown_terracotta": "Барнаста теракота",
  "block.minecraft.brown_wool": "Барнаста вовна",
  "block.minecraft.bubble_column": "Колона мыляных буль",
  "block.minecraft.bubble_coral": "Ґомбулный корал",
  "block.minecraft.bubble_coral_block": "Блок ґомбулного корала",
  "block.minecraft.bubble_coral_fan": "Ґомбулный корал-повівачка",
  "block.minecraft.bubble_coral_wall_fan": "Ґомбулный горізонталный корал-повівачка",
  "block.minecraft.budding_amethyst": "Цвітучый аметіст",
  "block.minecraft.bush": "Кряк",
  "block.minecraft.cactus": "Кактус",
  "block.minecraft.cactus_flower": "Цвітя кактуса",
  "block.minecraft.cake": "Торта",
  "block.minecraft.calcite": "Калціт",
  "block.minecraft.calibrated_sculk_sensor": "Калібрований cкалковый чуйник",
  "block.minecraft.campfire": "Ватра",
  "block.minecraft.candle": "Свічка",
  "block.minecraft.candle_cake": "Торта из свічков",
  "block.minecraft.carrots": "Морков",
  "block.minecraft.cartography_table": "Стул картоґрафісты",
  "block.minecraft.carved_pumpkin": "Урізана дыня",
  "block.minecraft.cauldron": "Котел",
  "block.minecraft.cave_air": "Печерный луфт",
  "block.minecraft.cave_vines": "Печирні ліаны",
  "block.minecraft.cave_vines_plant": "Быля печерної ліаны",
  "block.minecraft.chain": "Жилізный ланц",
  "block.minecraft.chain_command_block": "Ланцовый наказовый блок",
  "block.minecraft.cherry_button": "Вишнёвый ґомбик",
  "block.minecraft.cherry_door": "Вишнёві двирі",
  "block.minecraft.cherry_fence": "Вишнёвый плут",
  "block.minecraft.cherry_fence_gate": "Вишнёва капурка",
  "block.minecraft.cherry_hanging_sign": "Вишнёва увіска",
  "block.minecraft.cherry_leaves": "Вишнёвоє листя",
  "block.minecraft.cherry_log": "Вишнёвый кымак",
  "block.minecraft.cherry_planks": "Вишнёві дощкы",
  "block.minecraft.cherry_pressure_plate": "Вишнёва ступова пластина",
  "block.minecraft.cherry_sapling": "Вишнёвый скіпиць",
  "block.minecraft.cherry_shelf": "Вишнёва полиця",
  "block.minecraft.cherry_sign": "Вишнёва табличка",
  "block.minecraft.cherry_slab": "Вишнёва плита",
  "block.minecraft.cherry_stairs": "Вишнёві ґарадічі",
  "block.minecraft.cherry_trapdoor": "Вишнёвый пролаз",
  "block.minecraft.cherry_wall_hanging_sign": "Вишнёва стінна увіска",
  "block.minecraft.cherry_wall_sign": "Вишнёва стінна табличка",
  "block.minecraft.cherry_wood": "Вишнёвоє дерево",
  "block.minecraft.chest": "Лада",
  "block.minecraft.chipped_anvil": "Хоснованоє ковало",
  "block.minecraft.chiseled_bookshelf": "Точеный книжный реґал",
  "block.minecraft.chiseled_copper": "Точена мідь",
  "block.minecraft.chiseled_deepslate": "Точеный лупаный глуболупок",
  "block.minecraft.chiseled_nether_bricks": "Точеноє недер-цигля",
  "block.minecraft.chiseled_polished_blackstone": "Точеный полірованый чорновчак",
  "block.minecraft.chiseled_quartz_block": "Точеный блок кварца",
  "block.minecraft.chiseled_red_sandstone": "Точеный черленый пісковиць",
  "block.minecraft.chiseled_resin_bricks": "Точеноє смоляноє цигля",
  "block.minecraft.chiseled_sandstone": "Точеный пісковиць",
  "block.minecraft.chiseled_stone_bricks": "Точеноє камняноє цигля",
  "block.minecraft.chiseled_tuff": "Точеный туф",
  "block.minecraft.chiseled_tuff_bricks": "Точеноє туфовоє цигля",
  "block.minecraft.chorus_flower": "Цвітя хоруса",
  "block.minecraft.chorus_plant": "Хорус",
  "block.minecraft.clay": "Глина",
  "block.minecraft.closed_eyeblossom": "Закрыта очиця",
  "block.minecraft.coal_block": "Блок угля",
  "block.minecraft.coal_ore": "Угляна руда",
  "block.minecraft.coarse_dirt": "Камняниста зимля",
  "block.minecraft.cobbled_deepslate": "Лупаный глуболупок",
  "block.minecraft.cobbled_deepslate_slab": "Лупана глуболупкова плита",
  "block.minecraft.cobbled_deepslate_stairs": "Лупані глуболупкові ґарадічі",
  "block.minecraft.cobbled_deepslate_wall": "Лупаный глуболупковый мур",
  "block.minecraft.cobblestone": "Бурґовчак",
  "block.minecraft.cobblestone_slab": "Бурґова плита",
  "block.minecraft.cobblestone_stairs": "Бурґові ґарадічі",
  "block.minecraft.cobblestone_wall": "Бурґовый мур",
  "block.minecraft.cobweb": "Павучиня",
  "block.minecraft.cocoa": "Какао",
  "block.minecraft.command_block": "Наказовый блок",
  "block.minecraft.comparator": "Редстовновый рувнач",
  "block.minecraft.composter": "Компост",
  "block.minecraft.conduit": "Проводник",
  "block.minecraft.copper_bars": "Мідный рушт",
  "block.minecraft.copper_block": "Блок міди",
  "block.minecraft.copper_bulb": "Мідный лампош",
  "block.minecraft.copper_chain": "Мідный ланц",
  "block.minecraft.copper_chest": "Мідна лада",
  "block.minecraft.copper_door": "Мідні двирі",
  "block.minecraft.copper_golem_statue": "Статуя мідного ґолема",
  "block.minecraft.copper_grate": "Мідный рушт",
  "block.minecraft.copper_lantern": "Мідный вілонь",
  "block.minecraft.copper_ore": "Мідна руда",
  "block.minecraft.copper_torch": "Мідна факля",
  "block.minecraft.copper_trapdoor": "Мідный пролаз",
  "block.minecraft.copper_wall_torch": "Стінна мідна факля",
  "block.minecraft.cornflower": "Синьый блават",
  "block.minecraft.cracked_deepslate_bricks": "Попуканоє глубколупковоє цигля",
  "block.minecraft.cracked_deepslate_tiles": "Попуканый глубковый лупок",
  "block.minecraft.cracked_nether_bricks": "Попуканоє недер-цигля",
  "block.minecraft.cracked_polished_blackstone_bricks": "Попуканоє полірованоє чорновчаковоє цигля",
  "block.minecraft.cracked_stone_bricks": "Попуканоє камняноє цигля",
  "block.minecraft.crafter": "Майстровач",
  "block.minecraft.crafting_table": "Варштак",
  "block.minecraft.creaking_heart": "Корчово сердце",
  "block.minecraft.creeper_head": "Кріперова голова",
  "block.minecraft.creeper_wall_head": "Стінна кріперова голова",
  "block.minecraft.crimson_button": "Багровый ґомбик",
  "block.minecraft.crimson_door": "Багрові двирі",
  "block.minecraft.crimson_fence": "Багровый плут",
  "block.minecraft.crimson_fence_gate": "Багрова капурка",
  "block.minecraft.crimson_fungus": "Багровый гриб",
  "block.minecraft.crimson_hanging_sign": "Багрова увіска",
  "block.minecraft.crimson_hyphae": "Багрова гіфа",
  "block.minecraft.crimson_nylium": "Багровый нілій",
  "block.minecraft.crimson_planks": "Багрові дощкы",
  "block.minecraft.crimson_pressure_plate": "Багрова ступова пластина",
  "block.minecraft.crimson_roots": "Багровоє коріня",
  "block.minecraft.crimson_shelf": "Багрова полиця",
  "block.minecraft.crimson_sign": "Багрова табличка",
  "block.minecraft.crimson_slab": "Багрова плита",
  "block.minecraft.crimson_stairs": "Багрові ґарадічі",
  "block.minecraft.crimson_stem": "Багровоє быля",
  "block.minecraft.crimson_trapdoor": "Багровый пролаз",
  "block.minecraft.crimson_wall_hanging_sign": "Багрова стінна увіска",
  "block.minecraft.crimson_wall_sign": "Стінна багрова табличка",
  "block.minecraft.crying_obsidian": "Ревучый обсідіан",
  "block.minecraft.cut_copper": "Урізаный мідный блок",
  "block.minecraft.cut_copper_slab": "Урізана мідна плита",
  "block.minecraft.cut_copper_stairs": "Урізані мідні ґарадічі",
  "block.minecraft.cut_red_sandstone": "Урізаный черленый пісковиць",
  "block.minecraft.cut_red_sandstone_slab": "Урізана черлена пісковцёва плита",
  "block.minecraft.cut_sandstone": "Урізаный пісковиць",
  "block.minecraft.cut_sandstone_slab": "Урізана пісковцёва плита",
  "block.minecraft.cyan_banner": "Ціанова фана",
  "block.minecraft.cyan_bed": "Ціанова постиль",
  "block.minecraft.cyan_candle": "Ціанова свічка",
  "block.minecraft.cyan_candle_cake": "Торта из ціановов свічков",
  "block.minecraft.cyan_carpet": "Ціановый покровиць",
  "block.minecraft.cyan_concrete": "Ціановый бетон",
  "block.minecraft.cyan_concrete_powder": "Ціановый цімент",
  "block.minecraft.cyan_glazed_terracotta": "Ціанова поливана теракота",
  "block.minecraft.cyan_shulker_box": "Ціанова шалкер-ладичка",
  "block.minecraft.cyan_stained_glass": "Ціановоє скло",
  "block.minecraft.cyan_stained_glass_pane": "Ціановоє вучко",
  "block.minecraft.cyan_terracotta": "Ціанова теракота",
  "block.minecraft.cyan_wool": "Ціанова вовна",
  "block.minecraft.damaged_anvil": "Пошкодженоє ковало",
  "block.minecraft.dandelion": "Пупава",
  "block.minecraft.dark_oak_button": "Темный дубовый ґомбик",
  "block.minecraft.dark_oak_door": "Тимні дубові двирі",
  "block.minecraft.dark_oak_fence": "Темный дубовый плут",
  "block.minecraft.dark_oak_fence_gate": "Темна дубова капура",
  "block.minecraft.dark_oak_hanging_sign": "Темна дубова увіска",
  "block.minecraft.dark_oak_leaves": "Темноє дубовоє листя",
  "block.minecraft.dark_oak_log": "Темный дубовый кымак",
  "block.minecraft.dark_oak_planks": "Тимні дубові дощкы",
  "block.minecraft.dark_oak_pressure_plate": "Темна дубова ступова пластина",
  "block.minecraft.dark_oak_sapling": "Скіпиць темного дуба",
  "block.minecraft.dark_oak_shelf": "Темна дубова полиця",
  "block.minecraft.dark_oak_sign": "Темна дубова табличка",
  "block.minecraft.dark_oak_slab": "Темна дубова плита",
  "block.minecraft.dark_oak_stairs": "Тимні дубові ґарадічі",
  "block.minecraft.dark_oak_trapdoor": "Темный дубовый пролаз",
  "block.minecraft.dark_oak_wall_hanging_sign": "Темна дубова стінна увіска",
  "block.minecraft.dark_oak_wall_sign": "Темна дубова стінна табличка",
  "block.minecraft.dark_oak_wood": "Темноє дубовоє дерево",
  "block.minecraft.dark_prismarine": "Темный прізмарін",
  "block.minecraft.dark_prismarine_slab": "Темна прізмарінова плита",
  "block.minecraft.dark_prismarine_stairs": "Тимні прізмарінові ґарадічі",
  "block.minecraft.daylight_detector": "Чуйник денного світла",
  "block.minecraft.dead_brain_coral": "Мертвый мозґовый корал",
  "block.minecraft.dead_brain_coral_block": "Блок мертвых кораловых мозґув",
  "block.minecraft.dead_brain_coral_fan": "Мертвый мозґовый корал-повівачка",
  "block.minecraft.dead_brain_coral_wall_fan": "Мертвый мозґовый горізонталный корал-повівачка",
  "block.minecraft.dead_bubble_coral": "Мертвый ґомбулный корал",
  "block.minecraft.dead_bubble_coral_block": "Блок мертвого ґомбулного корала",
  "block.minecraft.dead_bubble_coral_fan": "Мертвый ґомбулный корал-повівачка",
  "block.minecraft.dead_bubble_coral_wall_fan": "Мертвый ґомбулный горізонталный корал-повівачка",
  "block.minecraft.dead_bush": "Мертвый корч",
  "block.minecraft.dead_fire_coral": "Мертвый огняный корал",
  "block.minecraft.dead_fire_coral_block": "Блок мертвого огняного корала",
  "block.minecraft.dead_fire_coral_fan": "Мертвый огняный корал-повівачка",
  "block.minecraft.dead_fire_coral_wall_fan": "Мертвый огняный горізонталный корал-повівачка",
  "block.minecraft.dead_horn_coral": "Мертвый мозулястый корал",
  "block.minecraft.dead_horn_coral_block": "Блок мертвого мозулястого корала",
  "block.minecraft.dead_horn_coral_fan": "Мертвый мозулястый корал-повівачка",
  "block.minecraft.dead_horn_coral_wall_fan": "Мертвый мозулястый горізонталный корал-повівачка",
  "block.minecraft.dead_tube_coral": "Мертвый трубчатый корал",
  "block.minecraft.dead_tube_coral_block": "Блок мертвого трубчатого корала",
  "block.minecraft.dead_tube_coral_fan": "Мертвый трубчатый корал-повівачка",
  "block.minecraft.dead_tube_coral_wall_fan": "Мертвый трубчатый горізонталный корал-повівачка",
  "block.minecraft.decorated_pot": "Украшеный череп",
  "block.minecraft.deepslate": "Глуболупок",
  "block.minecraft.deepslate_brick_slab": "Цигляна глуболупкова плита",
  "block.minecraft.deepslate_brick_stairs": "Цигляні глуболупкові ґарадічі",
  "block.minecraft.deepslate_brick_wall": "Цигляный глуболупковый мур",
  "block.minecraft.deepslate_bricks": "Глуболупковоє цигля",
  "block.minecraft.deepslate_coal_ore": "Глубкова угляна руда",
  "block.minecraft.deepslate_copper_ore": "Глубкова мідна руда",
  "block.minecraft.deepslate_diamond_ore": "Глубкова діямантова руда",
  "block.minecraft.deepslate_emerald_ore": "Глубкова смараґдова руда",
  "block.minecraft.deepslate_gold_ore": "Глубкова золота руда",
  "block.minecraft.deepslate_iron_ore": "Глубкова жилізна руда",
  "block.minecraft.deepslate_lapis_ore": "Глубкова азурітова руда",
  "block.minecraft.deepslate_redstone_ore": "Глубкова редстовнова руда",
  "block.minecraft.deepslate_tile_slab": "Коцкована глуболупкова плита",
  "block.minecraft.deepslate_tile_stairs": "Коцковані глуболупкові ґарадічі",
  "block.minecraft.deepslate_tile_wall": "Коцкованый глуболупковый мур",
  "block.minecraft.deepslate_tiles": "Глуболупкова коцка",
  "block.minecraft.detector_rail": "Колия-чуйник",
  "block.minecraft.diamond_block": "Блок діямантув",
  "block.minecraft.diamond_ore": "Діямантова руда",
  "block.minecraft.diorite": "Діоріт",
  "block.minecraft.diorite_slab": "Діорітова плита",
  "block.minecraft.diorite_stairs": "Діорітові ґарадічі",
  "block.minecraft.diorite_wall": "Діорітовый мур",
  "block.minecraft.dirt": "Зимля",
  "block.minecraft.dirt_path": "Пішник",
  "block.minecraft.dispenser": "Роздавач",
  "block.minecraft.dragon_egg": "Шарканёво яйце",
  "block.minecraft.dragon_head": "Шарканёва голова",
  "block.minecraft.dragon_wall_head": "Стінна шарканёва голова",
  "block.minecraft.dried_ghast": "Усушеный ґаст",
  "block.minecraft.dried_kelp_block": "Блок сушеної ламінарії",
  "block.minecraft.dripstone_block": "Нанореный камінь",
  "block.minecraft.dropper": "Умітовач",
  "block.minecraft.emerald_block": "Смараґдовый блок",
  "block.minecraft.emerald_ore": "Смараґдова руда",
  "block.minecraft.enchanting_table": "Забайный стул",
  "block.minecraft.end_gateway": "Ворота Енда",
  "block.minecraft.end_portal": "Енд-портал",
  "block.minecraft.end_portal_frame": "Рамка Енд-портала",
  "block.minecraft.end_rod": "Ендовська тычка",
  "block.minecraft.end_stone": "Енд-камінь",
  "block.minecraft.end_stone_brick_slab": "Енд-камняна цигляна плита",
  "block.minecraft.end_stone_brick_stairs": "Енд-камняні цигляні ґарадічі",
  "block.minecraft.end_stone_brick_wall": "Енд-камняный цигляный мур",
  "block.minecraft.end_stone_bricks": "Енд-камняноє цигля",
  "block.minecraft.ender_chest": "Ендерська лада",
  "block.minecraft.exposed_chiseled_copper": "Потимнівшый точеный мідный блок",
  "block.minecraft.exposed_copper": "Потимнівшый мідный блок",
  "block.minecraft.exposed_copper_bars": "Потимнівшый мідный рушт",
  "block.minecraft.exposed_copper_bulb": "Потимнівшый мідный лампош",
  "block.minecraft.exposed_copper_chain": "Потимнівшый мідный ланц",
  "block.minecraft.exposed_copper_chest": "Потимнівша мідна лада",
  "block.minecraft.exposed_copper_door": "Потимнівші мідні двирі",
  "block.minecraft.exposed_copper_golem_statue": "Потимнівша статуя мідного ґолема",
  "block.minecraft.exposed_copper_grate": "Потимнівшый мідный рушт",
  "block.minecraft.exposed_copper_lantern": "Потимнівшый мідный вілонь",
  "block.minecraft.exposed_copper_trapdoor": "Потимнівшый мідный пролаз",
  "block.minecraft.exposed_cut_copper": "Потимнівшый урізаный мідный блок",
  "block.minecraft.exposed_cut_copper_slab": "Потимнівша урізана мідна плита",
  "block.minecraft.exposed_cut_copper_stairs": "Потимнівші урізані мідні ґарадічі",
  "block.minecraft.exposed_lightning_rod": "Потимнівшый громозвод",
  "block.minecraft.farmland": "Ораниця",
  "block.minecraft.fern": "Папороть",
  "block.minecraft.fire": "Огинь",
  "block.minecraft.fire_coral": "Огняный корал",
  "block.minecraft.fire_coral_block": "Блок огняного корала",
  "block.minecraft.fire_coral_fan": "Огняный корал-повівачка",
  "block.minecraft.fire_coral_wall_fan": "Огняный горізонталный корал-повівачка",
  "block.minecraft.firefly_bush": "Корч из світлячками",
  "block.minecraft.fletching_table": "Стул лучника",
  "block.minecraft.flower_pot": "Череп",
  "block.minecraft.flowering_azalea": "Цвітуща азалія",
  "block.minecraft.flowering_azalea_leaves": "Листя цвітущої азалії",
  "block.minecraft.frogspawn": "Жаберина",
  "block.minecraft.frosted_ice": "Примерзлый люд",
  "block.minecraft.furnace": "Шпор",
  "block.minecraft.gilded_blackstone": "Золоченый чорновчак",
  "block.minecraft.glass": "Скло",
  "block.minecraft.glass_pane": "Вучко",
  "block.minecraft.glow_lichen": "Світячый лишайник",
  "block.minecraft.glowstone": "Світячый камінь",
  "block.minecraft.gold_block": "Блок золота",
  "block.minecraft.gold_ore": "Золота руда",
  "block.minecraft.golden_dandelion": "Золота купава",
  "block.minecraft.granite": "Ґраніт",
  "block.minecraft.granite_slab": "Ґранітова плита",
  "block.minecraft.granite_stairs": "Ґранітові ґарадічі",
  "block.minecraft.granite_wall": "Ґранітовый мур",
  "block.minecraft.grass": "Трава",
  "block.minecraft.grass_block": "Дирнь",
  "block.minecraft.gravel": "Шутер",
  "block.minecraft.gray_banner": "Сіра фана",
  "block.minecraft.gray_bed": "Сіра постиль",
  "block.minecraft.gray_candle": "Сіра свічка",
  "block.minecraft.gray_candle_cake": "Торта из сіров свічков",
  "block.minecraft.gray_carpet": "Сірый покровиць",
  "block.minecraft.gray_concrete": "Сірый бетон",
  "block.minecraft.gray_concrete_powder": "Сірый цімент",
  "block.minecraft.gray_glazed_terracotta": "Сіра поливана теракота",
  "block.minecraft.gray_shulker_box": "Сіра шалкер-ладичка",
  "block.minecraft.gray_stained_glass": "Сіроє скло",
  "block.minecraft.gray_stained_glass_pane": "Сіроє вучко",
  "block.minecraft.gray_terracotta": "Сіра теракота",
  "block.minecraft.gray_wool": "Сіра вовна",
  "block.minecraft.green_banner": "Зелена фана",
  "block.minecraft.green_bed": "Зелена постиль",
  "block.minecraft.green_candle": "Зелена свічка",
  "block.minecraft.green_candle_cake": "Торта из зеленов свічков",
  "block.minecraft.green_carpet": "Зеленый покровиць",
  "block.minecraft.green_concrete": "Зеленый бетон",
  "block.minecraft.green_concrete_powder": "Зеленый цімент",
  "block.minecraft.green_glazed_terracotta": "Зелена поливана теракота",
  "block.minecraft.green_shulker_box": "Зелена шалкер-ладичка",
  "block.minecraft.green_stained_glass": "Зеленоє скло",
  "block.minecraft.green_stained_glass_pane": "Зеленоє вучко",
  "block.minecraft.green_terracotta": "Зелена теракота",
  "block.minecraft.green_wool": "Зелена вовна",
  "block.minecraft.grindstone": "Брус",
  "block.minecraft.hanging_roots": "Звисавучоє коріня",
  "block.minecraft.hay_block": "Бал сіна",
  "block.minecraft.heavy_core": "Чажкоє ядро",
  "block.minecraft.heavy_weighted_pressure_plate": "Чажка вагова пластина",
  "block.minecraft.honey_block": "Блок меда",
  "block.minecraft.honeycomb_block": "Блок вощины",
  "block.minecraft.hopper": "Тивчирь",
  "block.minecraft.horn_coral": "Мозулястый корал",
  "block.minecraft.horn_coral_block": "Блок мозулястого корала",
  "block.minecraft.horn_coral_fan": "Мозулястый корал-повівачка",
  "block.minecraft.horn_coral_wall_fan": "Мозулястый горізонталный корал-повівачка",
  "block.minecraft.ice": "Люд",
  "block.minecraft.infested_chiseled_stone_bricks": "Зараженоє точеноє камняноє цигля",
  "block.minecraft.infested_cobblestone": "Зараженый бурґовчак",
  "block.minecraft.infested_cracked_stone_bricks": "Зараженоє попуканоє камняноє цигля",
  "block.minecraft.infested_deepslate": "Зараженый глубковый лупок",
  "block.minecraft.infested_mossy_stone_bricks": "Зараженоє замохнатілоє камняноє цигля",
  "block.minecraft.infested_stone": "Зараженый камінь",
  "block.minecraft.infested_stone_bricks": "Зараженоє камняноє цигля",
  "block.minecraft.iron_bars": "Жилізный рушт",
  "block.minecraft.iron_block": "Блок жиліза",
  "block.minecraft.iron_chain": "Жилізный ланц",
  "block.minecraft.iron_door": "Жилізні двирі",
  "block.minecraft.iron_ore": "Жилізна руда",
  "block.minecraft.iron_trapdoor": "Жилізный пролаз",
  "block.minecraft.jack_o_lantern": "Джекув світилник",
  "block.minecraft.jigsaw": "Пазел",
  "block.minecraft.jukebox": "Ґрамофон",
  "block.minecraft.jungle_button": "Джунґловый ґомбик",
  "block.minecraft.jungle_door": "Джунґлові двирі",
  "block.minecraft.jungle_fence": "Джунґловый плут",
  "block.minecraft.jungle_fence_gate": "Джунґлова капура",
  "block.minecraft.jungle_hanging_sign": "Джунґлова увіска",
  "block.minecraft.jungle_leaves": "Джунґловоє листя",
  "block.minecraft.jungle_log": "Джунґловый кымак",
  "block.minecraft.jungle_planks": "Джунґлові дощкы",
  "block.minecraft.jungle_pressure_plate": "Джунґлова ступова пластина",
  "block.minecraft.jungle_sapling": "Скіпиць джунґлового дерева",
  "block.minecraft.jungle_shelf": "Джунґлёва полиця",
  "block.minecraft.jungle_sign": "Джунґлова табличка",
  "block.minecraft.jungle_slab": "Джунґлова плита",
  "block.minecraft.jungle_stairs": "Джунґлові ґарадічі",
  "block.minecraft.jungle_trapdoor": "Джунґловый пролаз",
  "block.minecraft.jungle_wall_hanging_sign": "Джунґлова стінна увіска",
  "block.minecraft.jungle_wall_sign": "Джунґлова стінна табличка",
  "block.minecraft.jungle_wood": "Джунґловоє дерево",
  "block.minecraft.kelp": "Ламінарія",
  "block.minecraft.kelp_plant": "Быль ламінарії",
  "block.minecraft.ladder": "Лазиво",
  "block.minecraft.lantern": "Вілонь",
  "block.minecraft.lapis_block": "Азурітовый блок",
  "block.minecraft.lapis_ore": "Азурітова руда",
  "block.minecraft.large_amethyst_bud": "Груба аметістова бімбовка",
  "block.minecraft.large_fern": "Велика папороть",
  "block.minecraft.lava": "Лава",
  "block.minecraft.lava_cauldron": "Котел из лавов",
  "block.minecraft.leaf_litter": "Опалоє листя",
  "block.minecraft.lectern": "Казателниця",
  "block.minecraft.lever": "Пудойма",
  "block.minecraft.light": "Світло",
  "block.minecraft.light_blue_banner": "Голуба фана",
  "block.minecraft.light_blue_bed": "Голуба постиль",
  "block.minecraft.light_blue_candle": "Голуба свічка",
  "block.minecraft.light_blue_candle_cake": "Торта из небовов свічков",
  "block.minecraft.light_blue_carpet": "Голубый покровиць",
  "block.minecraft.light_blue_concrete": "Голубый бетон",
  "block.minecraft.light_blue_concrete_powder": "Голубый цімент",
  "block.minecraft.light_blue_glazed_terracotta": "Голуба поливана теракота",
  "block.minecraft.light_blue_shulker_box": "Голуба шалкер-ладичка",
  "block.minecraft.light_blue_stained_glass": "Голубоє скло",
  "block.minecraft.light_blue_stained_glass_pane": "Голубоє вучко",
  "block.minecraft.light_blue_terracotta": "Голуба теракота",
  "block.minecraft.light_blue_wool": "Голуба вовна",
  "block.minecraft.light_gray_banner": "Світлосіра фана",
  "block.minecraft.light_gray_bed": "Світлосіра постиль",
  "block.minecraft.light_gray_candle": "Світлосіра свічка",
  "block.minecraft.light_gray_candle_cake": "Торта из світлосіров свічков",
  "block.minecraft.light_gray_carpet": "Світлосірый покровиць",
  "block.minecraft.light_gray_concrete": "Світлосірый бетон",
  "block.minecraft.light_gray_concrete_powder": "Світлосірый цімент",
  "block.minecraft.light_gray_glazed_terracotta": "Світлосіра поливана теракота",
  "block.minecraft.light_gray_shulker_box": "Світлосіра шалкер-ладичка",
  "block.minecraft.light_gray_stained_glass": "Світлосіроє скло",
  "block.minecraft.light_gray_stained_glass_pane": "Світлосіроє вучко",
  "block.minecraft.light_gray_terracotta": "Світлосіра теракота",
  "block.minecraft.light_gray_wool": "Світлосіра вовна",
  "block.minecraft.light_weighted_pressure_plate": "Легка вагова пластина",
  "block.minecraft.lightning_rod": "Громозвод",
  "block.minecraft.lilac": "Орґона",
  "block.minecraft.lily_of_the_valley": "Дюндюрик",
  "block.minecraft.lily_pad": "Лотач",
  "block.minecraft.lime_banner": "Лаймова фана",
  "block.minecraft.lime_bed": "Лаймова постиль",
  "block.minecraft.lime_candle": "Лаймова свічка",
  "block.minecraft.lime_candle_cake": "Торта из лаймовов свічков",
  "block.minecraft.lime_carpet": "Лаймовый покровиць",
  "block.minecraft.lime_concrete": "Лаймовый бетон",
  "block.minecraft.lime_concrete_powder": "Лаймовый цімент",
  "block.minecraft.lime_glazed_terracotta": "Лаймова поливана теракота",
  "block.minecraft.lime_shulker_box": "Лаймова шалкер-ладичка",
  "block.minecraft.lime_stained_glass": "Лаймовоє скло",
  "block.minecraft.lime_stained_glass_pane": "Лаймовоє вучко",
  "block.minecraft.lime_terracotta": "Лаймова теракота",
  "block.minecraft.lime_wool": "Лаймова вовна",
  "block.minecraft.lodestone": "Маґнетовчак",
  "block.minecraft.loom": "Кросна",
  "block.minecraft.magenta_banner": "Пурпурова фана",
  "block.minecraft.magenta_bed": "Пурпурова постиль",
  "block.minecraft.magenta_candle": "Пурпурова свічка",
  "block.minecraft.magenta_candle_cake": "Торта из пурпурнов свічков",
  "block.minecraft.magenta_carpet": "Пурпуровый покровиць",
  "block.minecraft.magenta_concrete": "Пурпуровый бетон",
  "block.minecraft.magenta_concrete_powder": "Пурпуровый цімент",
  "block.minecraft.magenta_glazed_terracotta": "Пурпурова поливана теракота",
  "block.minecraft.magenta_shulker_box": "Пурпурова шалкер-ладичка",
  "block.minecraft.magenta_stained_glass": "Пурпуровоє скло",
  "block.minecraft.magenta_stained_glass_pane": "Пурпуровоє вучко",
  "block.minecraft.magenta_terracotta": "Пурпурова теракота",
  "block.minecraft.magenta_wool": "Пурпурова вовна",
  "block.minecraft.magma_block": "Блок маґмы",
  "block.minecraft.mangrove_button": "Манґровый ґомбик",
  "block.minecraft.mangrove_door": "Манґрові двирі",
  "block.minecraft.mangrove_fence": "Манґровый плут",
  "block.minecraft.mangrove_fence_gate": "Манґрова капура",
  "block.minecraft.mangrove_hanging_sign": "Манґрова увіска",
  "block.minecraft.mangrove_leaves": "Манґровоє листя",
  "block.minecraft.mangrove_log": "Манґровый кымак",
  "block.minecraft.mangrove_planks": "Манґрові дощкы",
  "block.minecraft.mangrove_pressure_plate": "Манґрова ступова пластина",
  "block.minecraft.mangrove_propagule": "Манґрова рустка",
  "block.minecraft.mangrove_roots": "Манґровоє коріня",
  "block.minecraft.mangrove_shelf": "Манґрова полиця",
  "block.minecraft.mangrove_sign": "Манґрова табличка",
  "block.minecraft.mangrove_slab": "Манґрова плита",
  "block.minecraft.mangrove_stairs": "Манґрові ґарадічі",
  "block.minecraft.mangrove_trapdoor": "Манґровый пролаз",
  "block.minecraft.mangrove_wall_hanging_sign": "Манґрова стінна увіска",
  "block.minecraft.mangrove_wall_sign": "Манґрова стінна табличка",
  "block.minecraft.mangrove_wood": "Манґровоє дерево",
  "block.minecraft.medium_amethyst_bud": "Серидня аметістова бімбовка",
  "block.minecraft.melon": "Грызачка",
  "block.minecraft.melon_stem": "Коріня грызачкы",
  "block.minecraft.moss_block": "Блок моху",
  "block.minecraft.moss_carpet": "Моховый покровиць",
  "block.minecraft.mossy_cobblestone": "Замохнатілый бурґовчак",
  "block.minecraft.mossy_cobblestone_slab": "Замохнатіла бурґова плита",
  "block.minecraft.mossy_cobblestone_stairs": "Замохнатілі бурґові ґарадічі",
  "block.minecraft.mossy_cobblestone_wall": "Замохнатілый бурґовый мур",
  "block.minecraft.mossy_stone_brick_slab": "Замохнатіла камняна цигляна плита",
  "block.minecraft.mossy_stone_brick_stairs": "Замохнатілі камняні цигляні ґарадічі",
  "block.minecraft.mossy_stone_brick_wall": "Замохнатілый камняный цигляный мур",
  "block.minecraft.mossy_stone_bricks": "Замохнатілоє камняноє цигля",
  "block.minecraft.moving_piston": "Рушавучый толок",
  "block.minecraft.mud": "Кал",
  "block.minecraft.mud_brick_slab": "Валькова цигляна плита",
  "block.minecraft.mud_brick_stairs": "Валькові цигляні ґарадічі",
  "block.minecraft.mud_brick_wall": "Вальковый цигляный мур",
  "block.minecraft.mud_bricks": "Вальковоє цигля",
  "block.minecraft.muddy_mangrove_roots": "Каляноє манґровоє коріня",
  "block.minecraft.mushroom_stem": "Грибный корінь",
  "block.minecraft.mycelium": "Грибня",
  "block.minecraft.nether_brick_fence": "Недер-цигляна плут",
  "block.minecraft.nether_brick_slab": "Недер-цигляна плита",
  "block.minecraft.nether_brick_stairs": "Недер-цигляні ґарадічі",
  "block.minecraft.nether_brick_wall": "Недер-цигляный мур",
  "block.minecraft.nether_bricks": "Недер-цигля",
  "block.minecraft.nether_gold_ore": "Недерова золота руда",
  "block.minecraft.nether_portal": "Недер портал",
  "block.minecraft.nether_quartz_ore": "Недер-кварцова руда",
  "block.minecraft.nether_sprouts": "Недерові русткы",
  "block.minecraft.nether_wart": "Недер-ворча",
  "block.minecraft.nether_wart_block": "Блок недер-ворчі",
  "block.minecraft.netherite_block": "Блок недеріта",
  "block.minecraft.netherrack": "Недеррек",
  "block.minecraft.note_block": "Нотна коцка",
  "block.minecraft.oak_button": "Дубовый ґомбик",
  "block.minecraft.oak_door": "Дубові двирі",
  "block.minecraft.oak_fence": "Дубовый плут",
  "block.minecraft.oak_fence_gate": "Дубова капура",
  "block.minecraft.oak_hanging_sign": "Дубова увіска",
  "block.minecraft.oak_leaves": "Дубовоє листя",
  "block.minecraft.oak_log": "Дубовый кымак",
  "block.minecraft.oak_planks": "Дубові дощкы",
  "block.minecraft.oak_pressure_plate": "Дубова ступова пластина",
  "block.minecraft.oak_sapling": "Скіпиць дуба",
  "block.minecraft.oak_shelf": "Дубова полиця",
  "block.minecraft.oak_sign": "Дубова табличка",
  "block.minecraft.oak_slab": "Дубова плита",
  "block.minecraft.oak_stairs": "Дубові ґарадічі",
  "block.minecraft.oak_trapdoor": "Дубовый пролаз",
  "block.minecraft.oak_wall_hanging_sign": "Дубова стінна увіска",
  "block.minecraft.oak_wall_sign": "Дубова стінна табличка",
  "block.minecraft.oak_wood": "Дубовоє дерево",
  "block.minecraft.observer": "Позирач",
  "block.minecraft.obsidian": "Обсідіан",
  "block.minecraft.ochre_froglight": "Окераста жабовка",
  "block.minecraft.ominous_banner": "Зловіща фана",
  "block.minecraft.open_eyeblossom": "Удкрыта очиця",
  "block.minecraft.orange_banner": "Оранджова фана",
  "block.minecraft.orange_bed": "Оранджова постиль",
  "block.minecraft.orange_candle": "Оранджева свічка",
  "block.minecraft.orange_candle_cake": "Торта из оранжевов свічков",
  "block.minecraft.orange_carpet": "Оранджовый покровиць",
  "block.minecraft.orange_concrete": "Оранджовый бетон",
  "block.minecraft.orange_concrete_powder": "Оранджовый цімент",
  "block.minecraft.orange_glazed_terracotta": "Оранджова поливана теракота",
  "block.minecraft.orange_shulker_box": "Оранджова шалкер-ладичка",
  "block.minecraft.orange_stained_glass": "Оранджовоє скло",
  "block.minecraft.orange_stained_glass_pane": "Оранджовоє вучко",
  "block.minecraft.orange_terracotta": "Оранджова теракота",
  "block.minecraft.orange_tulip": "Оранджовый туліпан",
  "block.minecraft.orange_wool": "Оранджова вовна",
  "block.minecraft.oxeye_daisy": "Каміла",
  "block.minecraft.oxidized_chiseled_copper": "Оксідованый точеный мідный блок",
  "block.minecraft.oxidized_copper": "Оскідованый мідный блок",
  "block.minecraft.oxidized_copper_bars": "Оксідованый мідный рушт",
  "block.minecraft.oxidized_copper_bulb": "Оксідованый мідный лампош",
  "block.minecraft.oxidized_copper_chain": "Оксідованый мідный ланц",
  "block.minecraft.oxidized_copper_chest": "Оксідована мідна лада",
  "block.minecraft.oxidized_copper_door": "Оксідовані мідні двирі",
  "block.minecraft.oxidized_copper_golem_statue": "Оксідована статуя мідного ґолема",
  "block.minecraft.oxidized_copper_grate": "Оксідованый мідный рушт",
  "block.minecraft.oxidized_copper_lantern": "Оксідованый мідный вілонь",
  "block.minecraft.oxidized_copper_trapdoor": "Оксідованый мідный пролаз",
  "block.minecraft.oxidized_cut_copper": "Оксідованый урізаный мідный блок",
  "block.minecraft.oxidized_cut_copper_slab": "Оксідована урізана мідна плита",
  "block.minecraft.oxidized_cut_copper_stairs": "Оксідовані урізані мідні ґарадічі",
  "block.minecraft.oxidized_lightning_rod": "Оксідованый громозвод",
  "block.minecraft.packed_ice": "Збитый люд",
  "block.minecraft.packed_mud": "Збитый кал",
  "block.minecraft.pale_hanging_moss": "Звисавучый блідый мох",
  "block.minecraft.pale_moss_block": "Блок блідого моху",
  "block.minecraft.pale_moss_carpet": "Блідый моховый покровиць",
  "block.minecraft.pale_oak_button": "Блідый дубовый ґомбик",
  "block.minecraft.pale_oak_door": "Бліді дубові двирі",
  "block.minecraft.pale_oak_fence": "Блідый дубовый плут",
  "block.minecraft.pale_oak_fence_gate": "Бліда дубова капура",
  "block.minecraft.pale_oak_hanging_sign": "Бліда будова увіска",
  "block.minecraft.pale_oak_leaves": "Листя блідого дуба",
  "block.minecraft.pale_oak_log": "Блідый дубовый кымак",
  "block.minecraft.pale_oak_planks": "Бліді дубові дощкы",
  "block.minecraft.pale_oak_pressure_plate": "Бліда дубова ступова пластина",
  "block.minecraft.pale_oak_sapling": "Скіпиць блідого дуба",
  "block.minecraft.pale_oak_shelf": "Бліда дубова полиця",
  "block.minecraft.pale_oak_sign": "Бліда дубова табличка",
  "block.minecraft.pale_oak_slab": "Бліда дубова плита",
  "block.minecraft.pale_oak_stairs": "Бліді дубові ґарадічі",
  "block.minecraft.pale_oak_trapdoor": "Блідый дубовый пролаз",
  "block.minecraft.pale_oak_wall_hanging_sign": "Бліда дубова стінна увіска",
  "block.minecraft.pale_oak_wall_sign": "Бліда дубова стінна табличка",
  "block.minecraft.pale_oak_wood": "Блідоє дубовоє дерево",
  "block.minecraft.pearlescent_froglight": "Перламутрова жабовка",
  "block.minecraft.peony": "Божа ружа",
  "block.minecraft.petrified_oak_slab": "Окамініла дубова плита",
  "block.minecraft.piglin_head": "Піґлінова голова",
  "block.minecraft.piglin_wall_head": "Стінна голова піґліна",
  "block.minecraft.pink_banner": "Ружова фана",
  "block.minecraft.pink_bed": "Ружова постиль",
  "block.minecraft.pink_candle": "Ружова свічка",
  "block.minecraft.pink_candle_cake": "Торта из ружовов свічков",
  "block.minecraft.pink_carpet": "Ружовый покровиць",
  "block.minecraft.pink_concrete": "Ружовый бетон",
  "block.minecraft.pink_concrete_powder": "Ружовый цімент",
  "block.minecraft.pink_glazed_terracotta": "Ружова поливана теракота",
  "block.minecraft.pink_petals": "Ружові лупенкы",
  "block.minecraft.pink_shulker_box": "Ружова шалкер-ладичка",
  "block.minecraft.pink_stained_glass": "Ружовоє скло",
  "block.minecraft.pink_stained_glass_pane": "Ружовоє вучко",
  "block.minecraft.pink_terracotta": "Ружова теракота",
  "block.minecraft.pink_tulip": "Ружовый туліпан",
  "block.minecraft.pink_wool": "Ружова вовна",
  "block.minecraft.piston": "Толок",
  "block.minecraft.piston_head": "Толок",
  "block.minecraft.pitcher_crop": "Рость джбаника",
  "block.minecraft.pitcher_plant": "Джбаник",
  "block.minecraft.player_head": "Голова бавляча",
  "block.minecraft.player_head.named": "Голова %s",
  "block.minecraft.player_wall_head": "Стінна бавлячова голова",
  "block.minecraft.podzol": "Пудзол",
  "block.minecraft.pointed_dripstone": "Заостренный нанореный камінь",
  "block.minecraft.polished_andesite": "Полірованый андезіт",
  "block.minecraft.polished_andesite_slab": "Полірована андезітова плита",
  "block.minecraft.polished_andesite_stairs": "Поліровані андезітові ґарадічі",
  "block.minecraft.polished_basalt": "Полірованый базалт",
  "block.minecraft.polished_blackstone": "Полірованый чорновчак",
  "block.minecraft.polished_blackstone_brick_slab": "Полірована чорновчакова плита",
  "block.minecraft.polished_blackstone_brick_stairs": "Поліровані чорновчакові ґарадічі",
  "block.minecraft.polished_blackstone_brick_wall": "Полірована чорновчакова цигляна стіна",
  "block.minecraft.polished_blackstone_bricks": "Полірованоє чорновчаковоє цигля",
  "block.minecraft.polished_blackstone_button": "Полірованый чорновчаковый ґомбик",
  "block.minecraft.polished_blackstone_pressure_plate": "Полірована чорновчакова ступова плита",
  "block.minecraft.polished_blackstone_slab": "Полірована чорновчакова плита",
  "block.minecraft.polished_blackstone_stairs": "Поліровані чорновчакові ґарадічі",
  "block.minecraft.polished_blackstone_wall": "Полірованый чорновчаковый мур",
  "block.minecraft.polished_deepslate": "Полірованый лупаный глуболупок",
  "block.minecraft.polished_deepslate_slab": "Полірована лупана глуболупкова плита",
  "block.minecraft.polished_deepslate_stairs": "Поліровані лупані глуболупкові ґарадічі",
  "block.minecraft.polished_deepslate_wall": "Полірованый лупаный глуболупковый мур",
  "block.minecraft.polished_diorite": "Полірованый діоріт",
  "block.minecraft.polished_diorite_slab": "Полірована діорітова плита",
  "block.minecraft.polished_diorite_stairs": "Поліровані діорітові ґарадічі",
  "block.minecraft.polished_granite": "Полірованый ґраніт",
  "block.minecraft.polished_granite_slab": "Полірована ґранітова плита",
  "block.minecraft.polished_granite_stairs": "Поліровані ґранітові ґарадічі",
  "block.minecraft.polished_tuff": "Полірованый туф",
  "block.minecraft.polished_tuff_slab": "Полірована туфова плита",
  "block.minecraft.polished_tuff_stairs": "Поліровані туфові ґарадічі",
  "block.minecraft.polished_tuff_wall": "Полірованый туфовый мур",
  "block.minecraft.poppy": "Мак",
  "block.minecraft.potatoes": "Крумплі",
  "block.minecraft.potted_acacia_sapling": "Череп из скіпцём акаца",
  "block.minecraft.potted_allium": "Плодисток у черепови",
  "block.minecraft.potted_azalea_bush": "Азалія у черепови",
  "block.minecraft.potted_azure_bluet": "Гаустонія синя у черепови",
  "block.minecraft.potted_bamboo": "Бамбус у черепови",
  "block.minecraft.potted_birch_sapling": "Череп из скіпцём березы",
  "block.minecraft.potted_blue_orchid": "Синя орхідея у черепови",
  "block.minecraft.potted_brown_mushroom": "Барнастый гриб у черепови",
  "block.minecraft.potted_cactus": "Кактус у черепови",
  "block.minecraft.potted_cherry_sapling": "Череп из скіпцём вишні",
  "block.minecraft.potted_closed_eyeblossom": "Закрыта очиця у черепови",
  "block.minecraft.potted_cornflower": "Блават у черепови",
  "block.minecraft.potted_crimson_fungus": "Багровый гриб у черепови",
  "block.minecraft.potted_crimson_roots": "Багровоє коріня у черепови",
  "block.minecraft.potted_dandelion": "Череп из купавов",
  "block.minecraft.potted_dark_oak_sapling": "Череп из скіпцём темного дуба",
  "block.minecraft.potted_dead_bush": "Мертвый корч у черепови",
  "block.minecraft.potted_fern": "Череп из папоротёв",
  "block.minecraft.potted_flowering_azalea_bush": "Цвітуща азалія у черепови",
  "block.minecraft.potted_golden_dandelion": "Череп из золотов купавов",
  "block.minecraft.potted_jungle_sapling": "Череп из скіпцём джунґлового дерева",
  "block.minecraft.potted_lily_of_the_valley": "Дюндюрик у черепови",
  "block.minecraft.potted_mangrove_propagule": "Череп из манґровым скіпцём",
  "block.minecraft.potted_oak_sapling": "Череп из скіпцём дуба",
  "block.minecraft.potted_open_eyeblossom": "Удкрыта очиця у черепови",
  "block.minecraft.potted_orange_tulip": "Оранджевый туліпан у черепови",
  "block.minecraft.potted_oxeye_daisy": "Руменок у черепови",
  "block.minecraft.potted_pale_oak_sapling": "Череп из скіпцём блідого дуба",
  "block.minecraft.potted_pink_tulip": "Ружовый туліпан у черепови",
  "block.minecraft.potted_poppy": "Мак у черепови",
  "block.minecraft.potted_red_mushroom": "Черленый гриб у черепови",
  "block.minecraft.potted_red_tulip": "Черленый туліпан у черепови",
  "block.minecraft.potted_spruce_sapling": "Череп из скіпцём смерекы",
  "block.minecraft.potted_torchflower": "Через из факлёвков",
  "block.minecraft.potted_warped_fungus": "Покрученый гриб у черепови",
  "block.minecraft.potted_warped_roots": "Покрученоє коріня у черепови",
  "block.minecraft.potted_white_tulip": "Білый туліпан у черепови",
  "block.minecraft.potted_wither_rose": "Відер-ружа у черепови",
  "block.minecraft.powder_snow": "Пухкый сніг",
  "block.minecraft.powder_snow_cauldron": "Котел из пухкым снігом",
  "block.minecraft.powered_rail": "Електроколия",
  "block.minecraft.prismarine": "Прізмарін",
  "block.minecraft.prismarine_brick_slab": "Прізмарінова цигляна плита",
  "block.minecraft.prismarine_brick_stairs": "Прізмарінові цигляні ґарадічі",
  "block.minecraft.prismarine_bricks": "Прізмарінова цигла",
  "block.minecraft.prismarine_slab": "Прізмарінова плита",
  "block.minecraft.prismarine_stairs": "Прізмарінові ґарадічі",
  "block.minecraft.prismarine_wall": "Прізмаріновый мур",
  "block.minecraft.pumpkin": "Дыня",
  "block.minecraft.pumpkin_stem": "Дынёвоє коріня",
  "block.minecraft.purple_banner": "Лілова фана",
  "block.minecraft.purple_bed": "Лілова постиль",
  "block.minecraft.purple_candle": "Лілова свічка",
  "block.minecraft.purple_candle_cake": "Торта из ліловов свічков",
  "block.minecraft.purple_carpet": "Ліловый покровиць",
  "block.minecraft.purple_concrete": "Ліловый бетон",
  "block.minecraft.purple_concrete_powder": "Ліловый цімент",
  "block.minecraft.purple_glazed_terracotta": "Лілова поливана теракота",
  "block.minecraft.purple_shulker_box": "Лілова шалкер-ладичка",
  "block.minecraft.purple_stained_glass": "Ліловоє скло",
  "block.minecraft.purple_stained_glass_pane": "Ліловоє вучко",
  "block.minecraft.purple_terracotta": "Лілова теракота",
  "block.minecraft.purple_wool": "Лілова вовна",
  "block.minecraft.purpur_block": "Пурпуровый блок",
  "block.minecraft.purpur_pillar": "Пурпурова колона",
  "block.minecraft.purpur_slab": "Пурпурова плита",
  "block.minecraft.purpur_stairs": "Пурпурові ґарадічі",
  "block.minecraft.quartz_block": "Блок кварца",
  "block.minecraft.quartz_bricks": "Кварцовоє цигля",
  "block.minecraft.quartz_pillar": "Кварцова колона",
  "block.minecraft.quartz_slab": "Кварцова плита",
  "block.minecraft.quartz_stairs": "Кварцові ґарадічі",
  "block.minecraft.rail": "Колия",
  "block.minecraft.raw_copper_block": "Блок неочищеної міди",
  "block.minecraft.raw_gold_block": "Блок неочищеного золота",
  "block.minecraft.raw_iron_block": "Блок неочищеного жиліза",
  "block.minecraft.red_banner": "Черлена фана",
  "block.minecraft.red_bed": "Черлена постиль",
  "block.minecraft.red_candle": "Черлена свічка",
  "block.minecraft.red_candle_cake": "Торта из черленов свічков",
  "block.minecraft.red_carpet": "Черленый покровиць",
  "block.minecraft.red_concrete": "Черленый бетон",
  "block.minecraft.red_concrete_powder": "Черленый цімент",
  "block.minecraft.red_glazed_terracotta": "Черлена поливана теракота",
  "block.minecraft.red_mushroom": "Черленый гриб",
  "block.minecraft.red_mushroom_block": "Блок черленого гриба",
  "block.minecraft.red_nether_brick_slab": "Черлена недер-цигляна плита",
  "block.minecraft.red_nether_brick_stairs": "Черлині недер-цигляні ґарадічі",
  "block.minecraft.red_nether_brick_wall": "Черленый недер-камняный мур",
  "block.minecraft.red_nether_bricks": "Черленоє недер-цигля",
  "block.minecraft.red_sand": "Черленый пісок",
  "block.minecraft.red_sandstone": "Черленый пісковиць",
  "block.minecraft.red_sandstone_slab": "Черлена пісковцёва плита",
  "block.minecraft.red_sandstone_stairs": "Черлині пісковцёві ґарадічі",
  "block.minecraft.red_sandstone_wall": "Черленый пісковцёвый мур",
  "block.minecraft.red_shulker_box": "Черлена шалкер-ладичка",
  "block.minecraft.red_stained_glass": "Черленоє скло",
  "block.minecraft.red_stained_glass_pane": "Черленоє вучко",
  "block.minecraft.red_terracotta": "Черлена теракота",
  "block.minecraft.red_tulip": "Черленый туліпан",
  "block.minecraft.red_wool": "Черлена вовна",
  "block.minecraft.redstone_block": "Редстовновый блок",
  "block.minecraft.redstone_lamp": "Редстовновый лампош",
  "block.minecraft.redstone_ore": "Редстовнова руда",
  "block.minecraft.redstone_torch": "Редстовнова факля",
  "block.minecraft.redstone_wall_torch": "Редстовнова стінна факля",
  "block.minecraft.redstone_wire": "Редстовновый друт",
  "block.minecraft.reinforced_deepslate": "Змоцненый глубковый лупок",
  "block.minecraft.repeater": "Редстовновый повторяч",
  "block.minecraft.repeating_command_block": "Повторявучый наказовый блок",
  "block.minecraft.resin_block": "Блок смолы",
  "block.minecraft.resin_brick_slab": "Смоляна цигляна плита",
  "block.minecraft.resin_brick_stairs": "Смоляні цигляні ґарадічі",
  "block.minecraft.resin_brick_wall": "Смоляный цигляный мур",
  "block.minecraft.resin_bricks": "Смоляноє цигля",
  "block.minecraft.resin_clump": "Грудка смолы",
  "block.minecraft.respawn_anchor": "Котва уброды",
  "block.minecraft.rooted_dirt": "Коріниста зимля",
  "block.minecraft.rose_bush": "Корч ружі",
  "block.minecraft.sand": "Пісок",
  "block.minecraft.sandstone": "Пісковиць",
  "block.minecraft.sandstone_slab": "Пісковцёва плита",
  "block.minecraft.sandstone_stairs": "Пісковцёві ґарадічі",
  "block.minecraft.sandstone_wall": "Пісковцёвый мур",
  "block.minecraft.scaffolding": "Алаші",
  "block.minecraft.sculk": "Скалк",
  "block.minecraft.sculk_catalyst": "Скалковый каталізатор",
  "block.minecraft.sculk_sensor": "Скалковый чуйник",
  "block.minecraft.sculk_shrieker": "Скалковый гойкаш",
  "block.minecraft.sculk_vein": "Скалкова жыла",
  "block.minecraft.sea_lantern": "Морськый вілонь",
  "block.minecraft.sea_pickle": "Морськый огурок",
  "block.minecraft.seagrass": "Морська трава",
  "block.minecraft.set_spawn": "Становено місто уброды",
  "block.minecraft.short_dry_grass": "Низька суха трава",
  "block.minecraft.short_grass": "Низька трава",
  "block.minecraft.shroomlight": "Грибосвіт",
  "block.minecraft.shulker_box": "Шалкер-ладичка",
  "block.minecraft.skeleton_skull": "Кустякова копоня",
  "block.minecraft.skeleton_wall_skull": "Стінна кустякова копоня",
  "block.minecraft.slime_block": "Блок слызи",
  "block.minecraft.small_amethyst_bud": "Мала аметістова бімбовка",
  "block.minecraft.small_dripleaf": "Малинькоє капкадло",
  "block.minecraft.smithing_table": "Стул ковача",
  "block.minecraft.smoker": "Будилка",
  "block.minecraft.smooth_basalt": "Гладкый базалт",
  "block.minecraft.smooth_quartz": "Блок гладкого кварца",
  "block.minecraft.smooth_quartz_slab": "Гладка кварцова плита",
  "block.minecraft.smooth_quartz_stairs": "Гладкі кварцові ґарадічі",
  "block.minecraft.smooth_red_sandstone": "Гладкый черленый пісковиць",
  "block.minecraft.smooth_red_sandstone_slab": "Гладка черлена пісковцёва плита",
  "block.minecraft.smooth_red_sandstone_stairs": "Гладкі черлині пісковцёві ґарадічі",
  "block.minecraft.smooth_sandstone": "Гладкый пісковиць",
  "block.minecraft.smooth_sandstone_slab": "Гладка пісковцёва плита",
  "block.minecraft.smooth_sandstone_stairs": "Гладкі пісковцёві ґарадічі",
  "block.minecraft.smooth_stone": "Гладкый камінь",
  "block.minecraft.smooth_stone_slab": "Гладка камняна плита",
  "block.minecraft.sniffer_egg": "Яйце пахача",
  "block.minecraft.snow": "Сніг",
  "block.minecraft.snow_block": "Блок сніга",
  "block.minecraft.soul_campfire": "Ватра душ",
  "block.minecraft.soul_fire": "Ватра душ",
  "block.minecraft.soul_lantern": "Вілонь душ",
  "block.minecraft.soul_sand": "Пісок душ",
  "block.minecraft.soul_soil": "Пісковина душ",
  "block.minecraft.soul_torch": "Факля душ",
  "block.minecraft.soul_wall_torch": "Стінна факля душ",
  "block.minecraft.spawn.not_valid": "Не маєте постели вадь заряженої котвы уброды, авадь сут недосяжні",
  "block.minecraft.spawner": "Спавнер монструв",
  "block.minecraft.spawner.desc1": "Схосновано яиць узыва:",
  "block.minecraft.spawner.desc2": "Наштімує тіп створы",
  "block.minecraft.sponge": "Губка",
  "block.minecraft.spore_blossom": "Засізоцвіт",
  "block.minecraft.spruce_button": "Смерековый ґомбик",
  "block.minecraft.spruce_door": "Смерекові двирі",
  "block.minecraft.spruce_fence": "Смерековый плут",
  "block.minecraft.spruce_fence_gate": "Смерекова капура",
  "block.minecraft.spruce_hanging_sign": "Смерекова увіска",
  "block.minecraft.spruce_leaves": "Смерековоє листя",
  "block.minecraft.spruce_log": "Смерековый кымак",
  "block.minecraft.spruce_planks": "Смерекові дощкы",
  "block.minecraft.spruce_pressure_plate": "Смерекова ступова пластина",
  "block.minecraft.spruce_sapling": "Скіпиць смерекы",
  "block.minecraft.spruce_shelf": "Смерекова полиця",
  "block.minecraft.spruce_sign": "Смерекова табличка",
  "block.minecraft.spruce_slab": "Смерекова плита",
  "block.minecraft.spruce_stairs": "Смерекові ґарадічі",
  "block.minecraft.spruce_trapdoor": "Смерековый пролаз",
  "block.minecraft.spruce_wall_hanging_sign": "Смерекова стінна увіска",
  "block.minecraft.spruce_wall_sign": "Смерекова стінна табличка",
  "block.minecraft.spruce_wood": "Смерековоє дерево",
  "block.minecraft.sticky_piston": "Липкачый толок",
  "block.minecraft.stone": "Камінь",
  "block.minecraft.stone_brick_slab": "Камняна цигляна плита",
  "block.minecraft.stone_brick_stairs": "Камняні цигляні ґарадічі",
  "block.minecraft.stone_brick_wall": "Камняный цигляный мур",
  "block.minecraft.stone_bricks": "Камняноє цигля",
  "block.minecraft.stone_button": "Камняный ґомбик",
  "block.minecraft.stone_pressure_plate": "Камняна ступова пластина",
  "block.minecraft.stone_slab": "Камняна плита",
  "block.minecraft.stone_stairs": "Камняні ґарадічі",
  "block.minecraft.stonecutter": "Камінёрізач",
  "block.minecraft.stripped_acacia_log": "Убтесаный акацовый кымак",
  "block.minecraft.stripped_acacia_wood": "Убтесаноє акацовоє дерево",
  "block.minecraft.stripped_bamboo_block": "Блок убтесаного бамбуса",
  "block.minecraft.stripped_birch_log": "Убтесаный березовый кымак",
  "block.minecraft.stripped_birch_wood": "Убтесаноє березовоє дерево",
  "block.minecraft.stripped_cherry_log": "Убтесаный вишнёвый кымак",
  "block.minecraft.stripped_cherry_wood": "Убтесаноє вишнёвоє дерево",
  "block.minecraft.stripped_crimson_hyphae": "Убтесана багрова гіфа",
  "block.minecraft.stripped_crimson_stem": "Убтесаноє багровоє быля",
  "block.minecraft.stripped_dark_oak_log": "Убтесаный темный дубовый кымак",
  "block.minecraft.stripped_dark_oak_wood": "Убтесаноє темноє дубовоє дерево",
  "block.minecraft.stripped_jungle_log": "Убтесаный джунґловый кымак",
  "block.minecraft.stripped_jungle_wood": "Убтесаноє джунґловоє дерево",
  "block.minecraft.stripped_mangrove_log": "Убтесаный манґровый кымак",
  "block.minecraft.stripped_mangrove_wood": "Убтесаноє манґровоє дерево",
  "block.minecraft.stripped_oak_log": "Убтесаный дубовый кымак",
  "block.minecraft.stripped_oak_wood": "Убтесаноє дубовоє дерево",
  "block.minecraft.stripped_pale_oak_log": "Убтесаный блідый дубовый кымак",
  "block.minecraft.stripped_pale_oak_wood": "Убтесаноє блідоє дубовоє дерево",
  "block.minecraft.stripped_spruce_log": "Убтесаный смерековый кымак",
  "block.minecraft.stripped_spruce_wood": "Убтесаноє смерековоє дерево",
  "block.minecraft.stripped_warped_hyphae": "Убтесані покручині гіфы",
  "block.minecraft.stripped_warped_stem": "Убтесаноє покрученоє быля",
  "block.minecraft.structure_block": "Структурный блок",
  "block.minecraft.structure_void": "Структурна порожня",
  "block.minecraft.sugar_cane": "Цукрова тростина",
  "block.minecraft.sunflower": "Посонячник",
  "block.minecraft.suspicious_gravel": "Чудный шутер",
  "block.minecraft.suspicious_sand": "Чудный пісок",
  "block.minecraft.sweet_berry_bush": "Корч солодкых ягуд",
  "block.minecraft.tall_dry_grass": "Высока суха трава",
  "block.minecraft.tall_grass": "Высока трава",
  "block.minecraft.tall_seagrass": "Высока морська трава",
  "block.minecraft.target": "Цїль",
  "block.minecraft.terracotta": "Теракота",
  "block.minecraft.test_block": "Тестовый блок",
  "block.minecraft.test_instance_block": "Тестовый блок примірника",
  "block.minecraft.tinted_glass": "Тонованоє скло",
  "block.minecraft.tnt": "Дінаміт",
  "block.minecraft.tnt.disabled": "Убухы дінаміту удключині",
  "block.minecraft.torch": "Факля",
  "block.minecraft.torchflower": "Факлёвка",
  "block.minecraft.torchflower_crop": "Рустка факлёвкы",
  "block.minecraft.trapped_chest": "Лада-лапка",
  "block.minecraft.trial_spawner": "Спавнер испыток",
  "block.minecraft.tripwire": "Напин",
  "block.minecraft.tripwire_hook": "Напиновый гак",
  "block.minecraft.tube_coral": "Трубчатый корал",
  "block.minecraft.tube_coral_block": "Блок трубчатого корала",
  "block.minecraft.tube_coral_fan": "Трубчатый корал-повівачка",
  "block.minecraft.tube_coral_wall_fan": "Горізонталный трубчатый корал-повівачка",
  "block.minecraft.tuff": "Туф",
  "block.minecraft.tuff_brick_slab": "Туфова цигляна плита",
  "block.minecraft.tuff_brick_stairs": "Туфові цигляні ґарадічі",
  "block.minecraft.tuff_brick_wall": "Туфовый цигляный мур",
  "block.minecraft.tuff_bricks": "Туфовоє цигля",
  "block.minecraft.tuff_slab": "Туфова плита",
  "block.minecraft.tuff_stairs": "Туфові ґарадічі",
  "block.minecraft.tuff_wall": "Туфовый мур",
  "block.minecraft.turtle_egg": "Яйце корытниці",
  "block.minecraft.twisting_vines": "Виткі ліаны",
  "block.minecraft.twisting_vines_plant": "Повороз ліаны",
  "block.minecraft.vault": "Сейф",
  "block.minecraft.verdant_froglight": "Малахітова жабовка",
  "block.minecraft.vine": "Ліаны",
  "block.minecraft.void_air": "Вакуум",
  "block.minecraft.wall_torch": "Стінна факля",
  "block.minecraft.warped_button": "Покрученый ґомбик",
  "block.minecraft.warped_door": "Покручині двирі",
  "block.minecraft.warped_fence": "Покрученый плут",
  "block.minecraft.warped_fence_gate": "Покручена капурка",
  "block.minecraft.warped_fungus": "Покрученый гриб",
  "block.minecraft.warped_hanging_sign": "Покручена увіска",
  "block.minecraft.warped_hyphae": "Покручена гіфа",
  "block.minecraft.warped_nylium": "Покрученый нілій",
  "block.minecraft.warped_planks": "Покручині дощкы",
  "block.minecraft.warped_pressure_plate": "Покручена ступова плита",
  "block.minecraft.warped_roots": "Покрученоє коріня",
  "block.minecraft.warped_shelf": "Покручена полиця",
  "block.minecraft.warped_sign": "Покручена табличка",
  "block.minecraft.warped_slab": "Покручена плита",
  "block.minecraft.warped_stairs": "Покручині ґарадічі",
  "block.minecraft.warped_stem": "Покрученоє быля",
  "block.minecraft.warped_trapdoor": "Покрученый пролаз",
  "block.minecraft.warped_wall_hanging_sign": "Покручена стінна увіска",
  "block.minecraft.warped_wall_sign": "Покручена стінна табличка",
  "block.minecraft.warped_wart_block": "Блок покрученої ворчі",
  "block.minecraft.water": "Вода",
  "block.minecraft.water_cauldron": "Котел из водов",
  "block.minecraft.waxed_chiseled_copper": "Воскованый точеный мідный блок",
  "block.minecraft.waxed_copper_bars": "Воскованый мідный рушт",
  "block.minecraft.waxed_copper_block": "Воскованый мідный блок",
  "block.minecraft.waxed_copper_bulb": "Воскованый мідный лампош",
  "block.minecraft.waxed_copper_chain": "Воскованый мідный ланц",
  "block.minecraft.waxed_copper_chest": "Воскована мідна лада",
  "block.minecraft.waxed_copper_door": "Восковані мідні двирі",
  "block.minecraft.waxed_copper_golem_statue": "Воскована статуя мідного ґолема",
  "block.minecraft.waxed_copper_grate": "Воскованый мідный рушт",
  "block.minecraft.waxed_copper_lantern": "Воскованый мідный вілонь",
  "block.minecraft.waxed_copper_trapdoor": "Воскованый мідный пролаз",
  "block.minecraft.waxed_cut_copper": "Воскованый урізаный мідный блок",
  "block.minecraft.waxed_cut_copper_slab": "Воскована урізана мідна плита",
  "block.minecraft.waxed_cut_copper_stairs": "Восковані урізані мідні ґарадічі",
  "block.minecraft.waxed_exposed_chiseled_copper": "Воскованый потимнівшый точеный мідный блок",
  "block.minecraft.waxed_exposed_copper": "Воскованый потимнівшый мідный блок",
  "block.minecraft.waxed_exposed_copper_bars": "Воскованый потимнівшый мідный рушт",
  "block.minecraft.waxed_exposed_copper_bulb": "Воскованый потимнівшый мідный лампош",
  "block.minecraft.waxed_exposed_copper_chain": "Воскованый потимнівшый мідный ланц",
  "block.minecraft.waxed_exposed_copper_chest": "Воскована потимнівша мідна лада",
  "block.minecraft.waxed_exposed_copper_door": "Восковані потимнівші мідні двирі",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Воскована потимнівша статуя мідного ґолема",
  "block.minecraft.waxed_exposed_copper_grate": "Воскованый потимнівшый мідный рушт",
  "block.minecraft.waxed_exposed_copper_lantern": "Воскованый потимнівшый мідный вілонь",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Воскованый потимнівшый мідный пролаз",
  "block.minecraft.waxed_exposed_cut_copper": "Воскованый потимнівшый урізаный мідный блок",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Воскована потимнівша урізана мідна плита",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Восковані потимнівші урізані мідні ґарадічі",
  "block.minecraft.waxed_exposed_lightning_rod": "Воскованый потимнівшый громозвод",
  "block.minecraft.waxed_lightning_rod": "Воскованый громозвод",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Воскованый оксідованый точеный мідный блок",
  "block.minecraft.waxed_oxidized_copper": "Воскованый оксідованый мідный блок",
  "block.minecraft.waxed_oxidized_copper_bars": "Воскованый оксідованый мідный рушт",
  "block.minecraft.waxed_oxidized_copper_bulb": "Воскованый оксідованый мідный лампош",
  "block.minecraft.waxed_oxidized_copper_chain": "Воскованый оксідованый мідный ланц",
  "block.minecraft.waxed_oxidized_copper_chest": "Воскована оксідована мідна лада",
  "block.minecraft.waxed_oxidized_copper_door": "Восковані оксідовані мідні двирі",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Воскована оксідована статуя мідного ґолема",
  "block.minecraft.waxed_oxidized_copper_grate": "Воскованый оксідованый мідный рушт",
  "block.minecraft.waxed_oxidized_copper_lantern": "Воскованый оксідованый мідный вілонь",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Воскованый оксідованый мідный пролаз",
  "block.minecraft.waxed_oxidized_cut_copper": "Воскованый оксідованый урізаный мідный блок",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Воскована оксідована урізана мідна плита",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Восковані оксідовані урізані мідні ґарадічі",
  "block.minecraft.waxed_oxidized_lightning_rod": "Воскованый оксідованый громозвод",
  "block.minecraft.waxed_weathered_chiseled_copper": "Воскованый зостарілый точеный мідный блок",
  "block.minecraft.waxed_weathered_copper": "Воскованый зостарілый мідный блок",
  "block.minecraft.waxed_weathered_copper_bars": "Воскованый зостарілый мідный рушт",
  "block.minecraft.waxed_weathered_copper_bulb": "Воскованый зостарілый мідный лампош",
  "block.minecraft.waxed_weathered_copper_chain": "Воскованый зостарілый мідный ланц",
  "block.minecraft.waxed_weathered_copper_chest": "Воскована зостаріла мідна лада",
  "block.minecraft.waxed_weathered_copper_door": "Восковані зостарілі мідні двирі",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Воскована зостаріла статуя мідного ґолема",
  "block.minecraft.waxed_weathered_copper_grate": "Воскованый зостарілый мідный рушт",
  "block.minecraft.waxed_weathered_copper_lantern": "Воскованый зостарілый мідный вілонь",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Воскованый зостарілый мідный пролаз",
  "block.minecraft.waxed_weathered_cut_copper": "Воскованый зостарілый урізаный мідный блок",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Воскована зостаріла урізана мідна плита",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Восковані зостарілі урізані мідні ґарадічі",
  "block.minecraft.waxed_weathered_lightning_rod": "Воскованый зостарілый громозвод",
  "block.minecraft.weathered_chiseled_copper": "Зостарілый точеный мідный блок",
  "block.minecraft.weathered_copper": "Зостарілый мідный блок",
  "block.minecraft.weathered_copper_bars": "Зостарілый мідный рушт",
  "block.minecraft.weathered_copper_bulb": "Зостарілый мідный лампош",
  "block.minecraft.weathered_copper_chain": "Зостарілый мідный ланц",
  "block.minecraft.weathered_copper_chest": "Зостаріла мідна лада",
  "block.minecraft.weathered_copper_door": "Зостарілі мідні двирі",
  "block.minecraft.weathered_copper_golem_statue": "Зостаріла статуя мідного ґолема",
  "block.minecraft.weathered_copper_grate": "Зостарілый мідный рушт",
  "block.minecraft.weathered_copper_lantern": "Зостарілый мідный вілонь",
  "block.minecraft.weathered_copper_trapdoor": "Зостарілый мідный пролаз",
  "block.minecraft.weathered_cut_copper": "Зостарілый урізаный мідный блок",
  "block.minecraft.weathered_cut_copper_slab": "Зостаріла урізана мідна плита",
  "block.minecraft.weathered_cut_copper_stairs": "Зостарілі урізані мідні ґарадічі",
  "block.minecraft.weathered_lightning_rod": "Зостарілый громозвод",
  "block.minecraft.weeping_vines": "Плакучі ліаны",
  "block.minecraft.weeping_vines_plant": "Быля плакучої ліаны",
  "block.minecraft.wet_sponge": "Мокра губка",
  "block.minecraft.wheat": "Пшениця",
  "block.minecraft.white_banner": "Біла фана",
  "block.minecraft.white_bed": "Біла постиль",
  "block.minecraft.white_candle": "Біла свічка",
  "block.minecraft.white_candle_cake": "Торта из білов свічков",
  "block.minecraft.white_carpet": "Білый покровиць",
  "block.minecraft.white_concrete": "Білый бетон",
  "block.minecraft.white_concrete_powder": "Білый цімент",
  "block.minecraft.white_glazed_terracotta": "Біла поливана теракота",
  "block.minecraft.white_shulker_box": "Біла шалкер-ладичка",
  "block.minecraft.white_stained_glass": "Білоє скло",
  "block.minecraft.white_stained_glass_pane": "Білоє вучко",
  "block.minecraft.white_terracotta": "Біла теракота",
  "block.minecraft.white_tulip": "Білый туліпан",
  "block.minecraft.white_wool": "Біла вовна",
  "block.minecraft.wildflowers": "Полёві косиці",
  "block.minecraft.wither_rose": "Ружа Відера",
  "block.minecraft.wither_skeleton_skull": "Відер-кустякова копоня",
  "block.minecraft.wither_skeleton_wall_skull": "Стінна відер-кустякова копоня",
  "block.minecraft.yellow_banner": "Жовта фана",
  "block.minecraft.yellow_bed": "Жовта постиль",
  "block.minecraft.yellow_candle": "Жовта свічка",
  "block.minecraft.yellow_candle_cake": "Торта из жовтов свічков",
  "block.minecraft.yellow_carpet": "Жовтый покровиць",
  "block.minecraft.yellow_concrete": "Жовтый бетон",
  "block.minecraft.yellow_concrete_powder": "Жовтый цімент",
  "block.minecraft.yellow_glazed_terracotta": "Жовта поливана теракота",
  "block.minecraft.yellow_shulker_box": "Жовта шалкер-ладичка",
  "block.minecraft.yellow_stained_glass": "Жовтоє скло",
  "block.minecraft.yellow_stained_glass_pane": "Жовтоє вучко",
  "block.minecraft.yellow_terracotta": "Жовта теракота",
  "block.minecraft.yellow_wool": "Жовта вовна",
  "block.minecraft.zombie_head": "Зомбіёва голова",
  "block.minecraft.zombie_wall_head": "Стінна зомбіёва голова",
  "item.minecraft.acacia_boat": "Акацова лодька",
  "item.minecraft.acacia_chest_boat": "Акацова лодька из ладов",
  "item.minecraft.allay_spawn_egg": "Яйце из иношком",
  "item.minecraft.amethyst_shard": "Удскалина аметіста",
  "item.minecraft.angler_pottery_shard": "Черепина рыбаря",
  "item.minecraft.angler_pottery_sherd": "Черепина рыбаря",
  "item.minecraft.apple": "Яблыко",
  "item.minecraft.archer_pottery_shard": "Черепина лучника",
  "item.minecraft.archer_pottery_sherd": "Черепина лучника",
  "item.minecraft.armadillo_scute": "Дощочка корыткаря",
  "item.minecraft.armadillo_spawn_egg": "Яйце из корыткарём",
  "item.minecraft.armor_stand": "Пудставка на броні",
  "item.minecraft.arms_up_pottery_shard": "Черепина из руками над головов",
  "item.minecraft.arms_up_pottery_sherd": "Черепина из руками над головов",
  "item.minecraft.arrow": "Стріла",
  "item.minecraft.axolotl_bucket": "Відро из аксолотлом",
  "item.minecraft.axolotl_spawn_egg": "Яйце из акселотлём",
  "item.minecraft.baked_potato": "Пиченый крумпель",
  "item.minecraft.bamboo_chest_raft": "Бамбусова дараба из ладов",
  "item.minecraft.bamboo_raft": "Бамбусова дараба",
  "item.minecraft.bat_spawn_egg": "Яйце из мышперхачом",
  "item.minecraft.bee_spawn_egg": "Яйце из пчолов",
  "item.minecraft.beef": "Сыра марженина",
  "item.minecraft.beetroot": "Бурак",
  "item.minecraft.beetroot_seeds": "Насіня бурака",
  "item.minecraft.beetroot_soup": "Бурачанка",
  "item.minecraft.birch_boat": "Березова лодька",
  "item.minecraft.birch_chest_boat": "Березова лодька из ладов",
  "item.minecraft.black_bundle": "Чорный міщух",
  "item.minecraft.black_dye": "Чорноє фарбиво",
  "item.minecraft.black_harness": "Чорні хамы",
  "item.minecraft.blade_pottery_shard": "Черепина из острём",
  "item.minecraft.blade_pottery_sherd": "Черепина из острём",
  "item.minecraft.blaze_powder": "Ватрачськый порох",
  "item.minecraft.blaze_rod": "Ватрача тычка",
  "item.minecraft.blaze_spawn_egg": "Яйце из ватраком",
  "item.minecraft.blue_bundle": "Синьый міщух",
  "item.minecraft.blue_dye": "Синёє фарбиво",
  "item.minecraft.blue_egg": "Синёє яйце",
  "item.minecraft.blue_harness": "Сині хамы",
  "item.minecraft.bogged_spawn_egg": "Яйце из мочарьником",
  "item.minecraft.bolt_armor_trim_smithing_template": "Ковачська мінта",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Мінта «Болт»",
  "item.minecraft.bone": "Кустка",
  "item.minecraft.bone_meal": "Кустяный порох",
  "item.minecraft.book": "Книга",
  "item.minecraft.bordure_indented_banner_pattern": "Мінта «Зубковата крайка»",
  "item.minecraft.bow": "Лук",
  "item.minecraft.bowl": "Миска",
  "item.minecraft.bread": "Хліб",
  "item.minecraft.breeze_rod": "Віхряча тычка",
  "item.minecraft.breeze_spawn_egg": "Яйце из віхряком",
  "item.minecraft.brewer_pottery_shard": "Черепина варилника",
  "item.minecraft.brewer_pottery_sherd": "Черепина варилника",
  "item.minecraft.brewing_stand": "Варилна пудставка",
  "item.minecraft.brick": "Цигла",
  "item.minecraft.brown_bundle": "Барнастый міщух",
  "item.minecraft.brown_dye": "Барнастоє фарбиво",
  "item.minecraft.brown_egg": "Барнастоє яйце",
  "item.minecraft.brown_harness": "Барнасті хамы",
  "item.minecraft.brush": "Кефка",
  "item.minecraft.bucket": "Відро",
  "item.minecraft.bundle": "Міщух",
  "item.minecraft.bundle.empty": "Пустый",
  "item.minecraft.bundle.empty.description": "Годен убсяговати дакулко рузных предметув",
  "item.minecraft.bundle.full": "Повный",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Черепина из поломінём",
  "item.minecraft.burn_pottery_sherd": "Черепина из поломінём",
  "item.minecraft.camel_husk_spawn_egg": "Яйце из попаленов комілов",
  "item.minecraft.camel_spawn_egg": "Яйце из комілов",
  "item.minecraft.carrot": "Морков",
  "item.minecraft.carrot_on_a_stick": "Морков на тычці",
  "item.minecraft.cat_spawn_egg": "Яйце из мачков",
  "item.minecraft.cauldron": "Котел",
  "item.minecraft.cave_spider_spawn_egg": "Яйце из печерным пауком",
  "item.minecraft.chainmail_boots": "Карікові боканчі",
  "item.minecraft.chainmail_chestplate": "Панцирь-кошуля",
  "item.minecraft.chainmail_helmet": "Каріковый шішак",
  "item.minecraft.chainmail_leggings": "Карікові ногавиці",
  "item.minecraft.charcoal": "Деревноє угля",
  "item.minecraft.cherry_boat": "Вишнёва лодька",
  "item.minecraft.cherry_chest_boat": "Вишнёва лодька из ладов",
  "item.minecraft.chest_minecart": "Возик из ладов",
  "item.minecraft.chicken": "Сыра курятина",
  "item.minecraft.chicken_spawn_egg": "Яйце из курицёв",
  "item.minecraft.chorus_fruit": "Плод хоруса",
  "item.minecraft.clay_ball": "Грудка глия",
  "item.minecraft.clock": "Годинка",
  "item.minecraft.coal": "Угля",
  "item.minecraft.coast_armor_trim_smithing_template": "Ковачська мінта",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Мінта «Берег»",
  "item.minecraft.cocoa_beans": "Какаові бобы",
  "item.minecraft.cod": "Сыра вагря",
  "item.minecraft.cod_bucket": "Відро из вагрёв",
  "item.minecraft.cod_spawn_egg": "Яйце из вагрёв",
  "item.minecraft.command_block_minecart": "Возик из наказовым блоком",
  "item.minecraft.compass": "Компас",
  "item.minecraft.cooked_beef": "Стейк",
  "item.minecraft.cooked_chicken": "Смажена курятина",
  "item.minecraft.cooked_cod": "Смажена вагря",
  "item.minecraft.cooked_mutton": "Смажена баранина",
  "item.minecraft.cooked_porkchop": "Смаженоє свинськоє мнясо",
  "item.minecraft.cooked_rabbit": "Смажена труська",
  "item.minecraft.cooked_salmon": "Смаженый лосос",
  "item.minecraft.cookie": "Кекс",
  "item.minecraft.copper_axe": "Мідна фийса",
  "item.minecraft.copper_boots": "Мідні боканчі",
  "item.minecraft.copper_chestplate": "Мідный кірас",
  "item.minecraft.copper_golem_spawn_egg": "Яйце из мідным ґолемом",
  "item.minecraft.copper_helmet": "Мідный шішак",
  "item.minecraft.copper_hoe": "Мідна копачка",
  "item.minecraft.copper_horse_armor": "Мідна кунську збруя",
  "item.minecraft.copper_ingot": "Мідный удливок",
  "item.minecraft.copper_leggings": "Мідні ногавиці",
  "item.minecraft.copper_nautilus_armor": "Мідна наутілусова збруя",
  "item.minecraft.copper_nugget": "Мідный самородок",
  "item.minecraft.copper_pickaxe": "Мідный чекан",
  "item.minecraft.copper_shovel": "Мідна лопата",
  "item.minecraft.copper_spear": "Мідна піка",
  "item.minecraft.copper_sword": "Мідный меч",
  "item.minecraft.cow_spawn_egg": "Яйце из коровов",
  "item.minecraft.creaking_spawn_egg": "Яйце из корчом",
  "item.minecraft.creeper_banner_pattern": "Мінта фаны",
  "item.minecraft.creeper_banner_pattern.desc": "Значка кріпера",
  "item.minecraft.creeper_banner_pattern.new": "Мінта «Кріпер»",
  "item.minecraft.creeper_spawn_egg": "Яйце из кріпером",
  "item.minecraft.crossbow": "Самостріл",
  "item.minecraft.crossbow.projectile": "Набуй:",
  "item.minecraft.crossbow.projectile.multiple": "Проєктіл: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Проєктіл: %s",
  "item.minecraft.cyan_bundle": "Ціановый міщух",
  "item.minecraft.cyan_dye": "Ціановоє фарбиво",
  "item.minecraft.cyan_harness": "Ціанові хамы",
  "item.minecraft.danger_pottery_shard": "Черепина из грозьбов",
  "item.minecraft.danger_pottery_sherd": "Черепина из грозьбов",
  "item.minecraft.dark_oak_boat": "Темна дубова лодька",
  "item.minecraft.dark_oak_chest_boat": "Темна дубова лодька из ладов",
  "item.minecraft.debug_stick": "Удладжовальна тычка",
  "item.minecraft.debug_stick.empty": "%s не має даностий",
  "item.minecraft.debug_stick.select": "убрано «%s» (%s)",
  "item.minecraft.debug_stick.update": "«%s»: %s",
  "item.minecraft.diamond": "Діямант",
  "item.minecraft.diamond_axe": "Діямантова фийса",
  "item.minecraft.diamond_boots": "Діямантові боканчі",
  "item.minecraft.diamond_chestplate": "Діямантовый кірас",
  "item.minecraft.diamond_helmet": "Діямантовый шішак",
  "item.minecraft.diamond_hoe": "Діямантова копачка",
  "item.minecraft.diamond_horse_armor": "Діямантова кунська збруя",
  "item.minecraft.diamond_leggings": "Діямантові ногавиці",
  "item.minecraft.diamond_nautilus_armor": "Діямантова наутілусова збруя",
  "item.minecraft.diamond_pickaxe": "Діямантовый чекан",
  "item.minecraft.diamond_shovel": "Діямантова лопата",
  "item.minecraft.diamond_spear": "Діямантова піка",
  "item.minecraft.diamond_sword": "Діямантовый меч",
  "item.minecraft.disc_fragment_5": "Удломок плиты",
  "item.minecraft.disc_fragment_5.desc": "Ґрамофонова плита - 5",
  "item.minecraft.dolphin_spawn_egg": "Яйце из делфіном",
  "item.minecraft.donkey_spawn_egg": "Яйце из сомаром",
  "item.minecraft.dragon_breath": "Шарканёво дыханя",
  "item.minecraft.dried_kelp": "Сушена морська трава",
  "item.minecraft.drowned_spawn_egg": "Яйце из утоплеником",
  "item.minecraft.dune_armor_trim_smithing_template": "Ковачська мінта",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Мінта «Дуна»",
  "item.minecraft.echo_shard": "Удламок удгука",
  "item.minecraft.egg": "Яйце",
  "item.minecraft.elder_guardian_spawn_egg": "Яйце из старшым сокотачом",
  "item.minecraft.elytra": "Закрывкы",
  "item.minecraft.emerald": "Смараґд",
  "item.minecraft.enchanted_book": "Книга забаяня",
  "item.minecraft.enchanted_golden_apple": "Забаяноє золотоє яблыко",
  "item.minecraft.end_crystal": "Енд крістал",
  "item.minecraft.ender_dragon_spawn_egg": "Яйце из ендерськым шарканём",
  "item.minecraft.ender_eye": "Око Енда",
  "item.minecraft.ender_pearl": "Ендерська перла",
  "item.minecraft.enderman_spawn_egg": "Яйце из ендерменом",
  "item.minecraft.endermite_spawn_egg": "Яйце из ендермітом",
  "item.minecraft.evoker_spawn_egg": "Яйце из заклиначом",
  "item.minecraft.experience_bottle": "Фляша из скушиностями",
  "item.minecraft.explorer_pottery_shard": "Черепина зглядоватиля",
  "item.minecraft.explorer_pottery_sherd": "Черепина зглядоватиля",
  "item.minecraft.eye_armor_trim_smithing_template": "Ковачська мінта",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Мінта «Око»",
  "item.minecraft.feather": "Перо",
  "item.minecraft.fermented_spider_eye": "Гниличеноє паучоє око",
  "item.minecraft.field_masoned_banner_pattern": "Мінта «Цигляна позадина»",
  "item.minecraft.filled_map": "Мапа",
  "item.minecraft.fire_charge": "Огняный набуй",
  "item.minecraft.firework_rocket": "Фаєрверок",
  "item.minecraft.firework_rocket.flight": "Довгота літаня:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Звізда фаєрверка",
  "item.minecraft.firework_star.black": "Чорный",
  "item.minecraft.firework_star.blue": "Синьый",
  "item.minecraft.firework_star.brown": "Барнастый",
  "item.minecraft.firework_star.custom_color": "Наштімованый",
  "item.minecraft.firework_star.cyan": "Ціановый",
  "item.minecraft.firework_star.fade_to": "Загасати у",
  "item.minecraft.firework_star.flicker": "Блиманя",
  "item.minecraft.firework_star.gray": "Сірый",
  "item.minecraft.firework_star.green": "Зеленый",
  "item.minecraft.firework_star.light_blue": "Голубый ",
  "item.minecraft.firework_star.light_gray": "Світлосірый",
  "item.minecraft.firework_star.lime": "Лаймовый",
  "item.minecraft.firework_star.magenta": "Пурпуровый",
  "item.minecraft.firework_star.orange": "Оранджовый",
  "item.minecraft.firework_star.pink": "Ружовый",
  "item.minecraft.firework_star.purple": "Ліловый",
  "item.minecraft.firework_star.red": "Черленый",
  "item.minecraft.firework_star.shape": "Незнама форма",
  "item.minecraft.firework_star.shape.burst": "Плюск",
  "item.minecraft.firework_star.shape.creeper": "Кріпероподобный",
  "item.minecraft.firework_star.shape.large_ball": "Велика каріка",
  "item.minecraft.firework_star.shape.small_ball": "Мала каріка",
  "item.minecraft.firework_star.shape.star": "Звіздоподобный",
  "item.minecraft.firework_star.trail": "Слід",
  "item.minecraft.firework_star.white": "Білый",
  "item.minecraft.firework_star.yellow": "Жовтый",
  "item.minecraft.fishing_rod": "Удиця",
  "item.minecraft.flint": "Кремінь",
  "item.minecraft.flint_and_steel": "Кресало",
  "item.minecraft.flow_armor_trim_smithing_template": "Ковачська мінта",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Мінта «Потук»",
  "item.minecraft.flow_banner_pattern": "Мінта фаны",
  "item.minecraft.flow_banner_pattern.desc": "Потук",
  "item.minecraft.flow_banner_pattern.new": "Мінта «Потук»",
  "item.minecraft.flow_pottery_sherd": "Черепина из потоком",
  "item.minecraft.flower_banner_pattern": "Мінта фаны",
  "item.minecraft.flower_banner_pattern.desc": "Косиця",
  "item.minecraft.flower_banner_pattern.new": "Мінта «Косиця»",
  "item.minecraft.flower_pot": "Череп",
  "item.minecraft.fox_spawn_egg": "Яйце из лишков",
  "item.minecraft.friend_pottery_shard": "Черепина цімбора",
  "item.minecraft.friend_pottery_sherd": "Черепина цімбора",
  "item.minecraft.frog_spawn_egg": "Яйце из ґріґонцом",
  "item.minecraft.furnace_minecart": "Возик из шпором",
  "item.minecraft.ghast_spawn_egg": "Яйце из ґастом",
  "item.minecraft.ghast_tear": "Ґастова слыза",
  "item.minecraft.glass_bottle": "Скляна фляшка",
  "item.minecraft.glistering_melon_slice": "Блищача скыбка грызачкы",
  "item.minecraft.globe_banner_pattern": "Мінта фаны",
  "item.minecraft.globe_banner_pattern.desc": "Ґлобус",
  "item.minecraft.globe_banner_pattern.new": "Мінта «Ґлобус»",
  "item.minecraft.glow_berries": "Світячі ягоды",
  "item.minecraft.glow_ink_sac": "Світячый тінтовый міщук",
  "item.minecraft.glow_item_frame": "Світяча рамка",
  "item.minecraft.glow_squid_spawn_egg": "Яйце из світячым каламарём",
  "item.minecraft.glowstone_dust": "Світячый порох",
  "item.minecraft.goat_horn": "Цапурув руг",
  "item.minecraft.goat_spawn_egg": "Яйце из цапом",
  "item.minecraft.gold_ingot": "Золотый удливок",
  "item.minecraft.gold_nugget": "Золотый самородок",
  "item.minecraft.golden_apple": "Золотоє яблыко",
  "item.minecraft.golden_axe": "Золота фийса",
  "item.minecraft.golden_boots": "Золоті боканчі",
  "item.minecraft.golden_carrot": "Золота морков",
  "item.minecraft.golden_chestplate": "Золотый кірас",
  "item.minecraft.golden_helmet": "Золотый шішак",
  "item.minecraft.golden_hoe": "Золота копачка",
  "item.minecraft.golden_horse_armor": "Золота кунська збруя",
  "item.minecraft.golden_leggings": "Золоті ногавиці",
  "item.minecraft.golden_nautilus_armor": "Золота наутілусова збруя",
  "item.minecraft.golden_pickaxe": "Золотый чекан",
  "item.minecraft.golden_shovel": "Золота лопата",
  "item.minecraft.golden_spear": "Золота піка",
  "item.minecraft.golden_sword": "Золотый меч",
  "item.minecraft.gray_bundle": "Сірый міщух",
  "item.minecraft.gray_dye": "Сіроє фарбиво",
  "item.minecraft.gray_harness": "Сірі хамы",
  "item.minecraft.green_bundle": "Зеленый міщух",
  "item.minecraft.green_dye": "Зеленоє фарбиво",
  "item.minecraft.green_harness": "Зелині хамы",
  "item.minecraft.guardian_spawn_egg": "Яйце из сокотачом",
  "item.minecraft.gunpowder": "Пушковый порох",
  "item.minecraft.guster_banner_pattern": "Мінта фаны",
  "item.minecraft.guster_banner_pattern.desc": "Подув",
  "item.minecraft.guster_banner_pattern.new": "Мінта «Подув»",
  "item.minecraft.guster_pottery_sherd": "Черепина из подувом",
  "item.minecraft.happy_ghast_spawn_egg": "Яйце из благым ґастом",
  "item.minecraft.harness": "Хамы",
  "item.minecraft.heart_of_the_sea": "Сердце моря",
  "item.minecraft.heart_pottery_shard": "Черепина из сирдцём",
  "item.minecraft.heart_pottery_sherd": "Черепина из сирдцём",
  "item.minecraft.heartbreak_pottery_shard": "Черепина из роспуклым сирдцём",
  "item.minecraft.heartbreak_pottery_sherd": "Черепина из роспуклым сирдцём",
  "item.minecraft.hoglin_spawn_egg": "Яйце из гоґліном",
  "item.minecraft.honey_bottle": "Фляшка меду",
  "item.minecraft.honeycomb": "Пчолині вощины",
  "item.minecraft.hopper_minecart": "Возик из тивчирём",
  "item.minecraft.horse_spawn_egg": "Яйце из конём",
  "item.minecraft.host_armor_trim_smithing_template": "Ковачська мінта",
  "item.minecraft.host_armor_trim_smithing_template.new": "Мінта «Ґазда»",
  "item.minecraft.howl_pottery_shard": "Черепина вытя",
  "item.minecraft.howl_pottery_sherd": "Черепина вытя",
  "item.minecraft.husk_spawn_egg": "Яйце из попалинёшом",
  "item.minecraft.ink_sac": "Тінтовый міщук",
  "item.minecraft.iron_axe": "Жилізна фийса",
  "item.minecraft.iron_boots": "Жилізні боканчі",
  "item.minecraft.iron_chestplate": "Жилізный кірас",
  "item.minecraft.iron_golem_spawn_egg": "Яйце из жилізным ґолемом",
  "item.minecraft.iron_helmet": "Жилізный шішак",
  "item.minecraft.iron_hoe": "Жилізна копачка",
  "item.minecraft.iron_horse_armor": "Жилізна кунська збруя",
  "item.minecraft.iron_ingot": "Жилізный удливок",
  "item.minecraft.iron_leggings": "Жилізні ногавиці",
  "item.minecraft.iron_nautilus_armor": "Жилізна наутілусова збруя",
  "item.minecraft.iron_nugget": "Жилізный самородок",
  "item.minecraft.iron_pickaxe": "Жилізный чекан",
  "item.minecraft.iron_shovel": "Жилізна лопата",
  "item.minecraft.iron_spear": "Жилізна піка",
  "item.minecraft.iron_sword": "Жилізный меч",
  "item.minecraft.item_frame": "Рамка",
  "item.minecraft.jungle_boat": "Джунґлова лодька",
  "item.minecraft.jungle_chest_boat": "Джунґлова лодька из ладов",
  "item.minecraft.knowledge_book": "Книга зналостий",
  "item.minecraft.lapis_lazuli": "Азуріт",
  "item.minecraft.lava_bucket": "Відро лавы",
  "item.minecraft.lead": "Водило",
  "item.minecraft.leather": "Кожа",
  "item.minecraft.leather_boots": "Кожані боканчі",
  "item.minecraft.leather_chestplate": "Кожана туника",
  "item.minecraft.leather_helmet": "Кожаный клебан",
  "item.minecraft.leather_horse_armor": "Кожана кунська збруя",
  "item.minecraft.leather_leggings": "Кожані порткы",
  "item.minecraft.light_blue_bundle": "Голубый міщух",
  "item.minecraft.light_blue_dye": "Голубоє фарбиво",
  "item.minecraft.light_blue_harness": "Голубі хамы",
  "item.minecraft.light_gray_bundle": "Світлосірый міщух",
  "item.minecraft.light_gray_dye": "Світлосіроє фарбиво",
  "item.minecraft.light_gray_harness": "Світлосірі хамы",
  "item.minecraft.lime_bundle": "Лаймовый міщух",
  "item.minecraft.lime_dye": "Лаймовоє фарбиво",
  "item.minecraft.lime_harness": "Лаймові хамы",
  "item.minecraft.lingering_potion": "Мглавоє зіля",
  "item.minecraft.lingering_potion.effect.awkward": "Чудноє млавоє зіля",
  "item.minecraft.lingering_potion.effect.empty": "Мглавоє несоздаваймоє зіля",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Мглавоє зіля огнёстуйкости",
  "item.minecraft.lingering_potion.effect.harming": "Мглавоє зіля уразеня",
  "item.minecraft.lingering_potion.effect.healing": "Мглавоє зіля сціленя",
  "item.minecraft.lingering_potion.effect.infested": "Мглавоє зіля зараженя",
  "item.minecraft.lingering_potion.effect.invisibility": "Мглавоє зіля невидимости",
  "item.minecraft.lingering_potion.effect.leaping": "Мглавоє зіля скочности",
  "item.minecraft.lingering_potion.effect.levitation": "Мглавоє зіля левітації",
  "item.minecraft.lingering_potion.effect.luck": "Мглавоє зіля серинчі",
  "item.minecraft.lingering_potion.effect.mundane": "Обычайноє мглавоє зіля",
  "item.minecraft.lingering_potion.effect.night_vision": "Мглавоє зіля нучного нику",
  "item.minecraft.lingering_potion.effect.oozing": "Мглавоє зіля липкавости",
  "item.minecraft.lingering_potion.effect.poison": "Мглавоє зіля утровеня",
  "item.minecraft.lingering_potion.effect.regeneration": "Мглавоє зіля гоиня",
  "item.minecraft.lingering_potion.effect.slow_falling": "Мглавоє зіля тихого паданя",
  "item.minecraft.lingering_potion.effect.slowness": "Мглавоє зіля помалости",
  "item.minecraft.lingering_potion.effect.strength": "Мглавоє зіля силы",
  "item.minecraft.lingering_potion.effect.swiftness": "Мглавоє зіля скороты",
  "item.minecraft.lingering_potion.effect.thick": "Густоє мглавоє зіля",
  "item.minecraft.lingering_potion.effect.turtle_master": "Мглавоє зіля корытницької силы",
  "item.minecraft.lingering_potion.effect.water": "Мглава фляшка воды",
  "item.minecraft.lingering_potion.effect.water_breathing": "Мглавоє зіля водяного дыханя",
  "item.minecraft.lingering_potion.effect.weakness": "Мглавоє зіля слабости",
  "item.minecraft.lingering_potion.effect.weaving": "Мглавоє зіля плетеня",
  "item.minecraft.lingering_potion.effect.wind_charged": "Мглавоє зіля вітряного выбуху",
  "item.minecraft.llama_spawn_egg": "Яйце из ламов",
  "item.minecraft.lodestone_compass": "Намаґнетізованый компас",
  "item.minecraft.mace": "Довбня",
  "item.minecraft.magenta_bundle": "Пурпуровый міщух",
  "item.minecraft.magenta_dye": "Пурпуровоє фарбиво",
  "item.minecraft.magenta_harness": "Пурпірові хамы",
  "item.minecraft.magma_cream": "Маґмовый крем",
  "item.minecraft.magma_cube_spawn_egg": "Яйце из маґмовым слызаком",
  "item.minecraft.mangrove_boat": "Манґрова лодька",
  "item.minecraft.mangrove_chest_boat": "Манґрова лодька из ладов",
  "item.minecraft.map": "Пуста мапа",
  "item.minecraft.melon_seeds": "Насіня грызачкы",
  "item.minecraft.melon_slice": "Скыбка грызачкы",
  "item.minecraft.milk_bucket": "Відро молока",
  "item.minecraft.minecart": "Возик",
  "item.minecraft.miner_pottery_shard": "Черепина баняча",
  "item.minecraft.miner_pottery_sherd": "Черепина баняча",
  "item.minecraft.mojang_banner_pattern": "Мінта фаны",
  "item.minecraft.mojang_banner_pattern.desc": "Предмет",
  "item.minecraft.mojang_banner_pattern.new": "Мінта «Штось»",
  "item.minecraft.mooshroom_spawn_egg": "Яйце из мушрумов",
  "item.minecraft.mourner_pottery_shard": "Черепина жалости",
  "item.minecraft.mourner_pottery_sherd": "Черепина жалости",
  "item.minecraft.mule_spawn_egg": "Яйце из мулом",
  "item.minecraft.mushroom_stew": "Грибова поливка",
  "item.minecraft.music_disc_11": "Ґрамофонова плита",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Ґрамофонова плита",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Ґрамофонова плита",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Ґрамофонова плита",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Ґрамофонова плита",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Ґрамофонова плита",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Ґрамофонова плита",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Ґрамофонова плита",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Гудацька коробка)",
  "item.minecraft.music_disc_far": "Ґрамофонова плита",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Ґрамофонова плита",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Ґрамофонова плита",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Ґрамофонова плита",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Ґрамофонова плита",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Ґрамофонова плита",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Ґрамофонова плита",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Ґрамофонова плита",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Ґрамофонова плита",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Ґрамофонова плита",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Ґрамофонова плита",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy – Tears",
  "item.minecraft.music_disc_wait": "Ґрамофонова плита",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Ґрамофонова плита",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Сыра баранина",
  "item.minecraft.name_tag": "Цетлик",
  "item.minecraft.nautilus_shell": "Наутілусова шкарупа",
  "item.minecraft.nautilus_spawn_egg": "Яйце из наутілусом",
  "item.minecraft.nether_brick": "Недер-цигла",
  "item.minecraft.nether_star": "Недерова звізда",
  "item.minecraft.nether_wart": "Недер-ворча",
  "item.minecraft.netherite_axe": "Недерітова фийса",
  "item.minecraft.netherite_boots": "Недерітові боканчі",
  "item.minecraft.netherite_chestplate": "Недерітовый кірас",
  "item.minecraft.netherite_helmet": "Недерітовый шішак",
  "item.minecraft.netherite_hoe": "Недерітова копачка",
  "item.minecraft.netherite_horse_armor": "Недерітова кунська збруя",
  "item.minecraft.netherite_ingot": "Недерітовый удливок",
  "item.minecraft.netherite_leggings": "Недерітові ногавиці",
  "item.minecraft.netherite_nautilus_armor": "Недерітова наутілусова збруя",
  "item.minecraft.netherite_pickaxe": "Недерітовый чекан",
  "item.minecraft.netherite_scrap": "Недерітовый удломок",
  "item.minecraft.netherite_shovel": "Недерітова лопата",
  "item.minecraft.netherite_spear": "Недерітова піка",
  "item.minecraft.netherite_sword": "Недерітовый меч",
  "item.minecraft.netherite_upgrade_smithing_template": "Ковачська мінта",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Недерітовоє уліпшеня",
  "item.minecraft.oak_boat": "Дубова лодька",
  "item.minecraft.oak_chest_boat": "Дубова лодька из ладов",
  "item.minecraft.ocelot_spawn_egg": "Яйце из оцетолом",
  "item.minecraft.ominous_bottle": "Зловіща фляшка",
  "item.minecraft.ominous_trial_key": "Зловіщый ключ испыток",
  "item.minecraft.orange_bundle": "Оранджевый міщух",
  "item.minecraft.orange_dye": "Оранджовоє фарбиво",
  "item.minecraft.orange_harness": "Оранджові хамы",
  "item.minecraft.painting": "Образ",
  "item.minecraft.pale_oak_boat": "Бліда дубова лодька",
  "item.minecraft.pale_oak_chest_boat": "Бліда дубова лодька из ладов",
  "item.minecraft.panda_spawn_egg": "Яйце из пандов",
  "item.minecraft.paper": "Папірь",
  "item.minecraft.parched_spawn_egg": "Яйце из сухарьом",
  "item.minecraft.parrot_spawn_egg": "Яйце из папуґаём",
  "item.minecraft.phantom_membrane": "Фантомова плінка",
  "item.minecraft.phantom_spawn_egg": "Яйце из фантомом",
  "item.minecraft.pig_spawn_egg": "Яйце из свинёв",
  "item.minecraft.piglin_banner_pattern": "Мінта фаны",
  "item.minecraft.piglin_banner_pattern.desc": "Фаца",
  "item.minecraft.piglin_banner_pattern.new": "Мінта «Фаца»",
  "item.minecraft.piglin_brute_spawn_egg": "Яйце из суровым піґліном",
  "item.minecraft.piglin_spawn_egg": "Яйце из піґліном",
  "item.minecraft.pillager_spawn_egg": "Яйце из раблувом",
  "item.minecraft.pink_bundle": "Ружовый міщух",
  "item.minecraft.pink_dye": "Ружовоє фарбиво",
  "item.minecraft.pink_harness": "Ружові хамы",
  "item.minecraft.pitcher_plant": "Джбаник",
  "item.minecraft.pitcher_pod": "Стручок джбаника",
  "item.minecraft.plenty_pottery_shard": "Черепина гойности",
  "item.minecraft.plenty_pottery_sherd": "Черепина гойности",
  "item.minecraft.poisonous_potato": "Утровный крумпель",
  "item.minecraft.polar_bear_spawn_egg": "Яйце из ледовым мидвідём",
  "item.minecraft.popped_chorus_fruit": "Спиченый плод хоруса",
  "item.minecraft.porkchop": "Сыроє свинськоє мнясо",
  "item.minecraft.potato": "Крумпель",
  "item.minecraft.potion": "Зіля",
  "item.minecraft.potion.effect.awkward": "Чудноє зіля",
  "item.minecraft.potion.effect.empty": "Несоздаваймоє зіля",
  "item.minecraft.potion.effect.fire_resistance": "Зіля огнёстуйкости",
  "item.minecraft.potion.effect.harming": "Зіля уразеня",
  "item.minecraft.potion.effect.healing": "Зіля ліченя",
  "item.minecraft.potion.effect.infested": "Зіля зараженя",
  "item.minecraft.potion.effect.invisibility": "Зіля невидимости",
  "item.minecraft.potion.effect.leaping": "Зіля скочности",
  "item.minecraft.potion.effect.levitation": "Зіля левітації",
  "item.minecraft.potion.effect.luck": "Зіля серинчі",
  "item.minecraft.potion.effect.mundane": "Обычайноє зіля",
  "item.minecraft.potion.effect.night_vision": "Зіля нучного нику",
  "item.minecraft.potion.effect.oozing": "Зіля липкавости",
  "item.minecraft.potion.effect.poison": "Зіля утровы",
  "item.minecraft.potion.effect.regeneration": "Зіля гоиня",
  "item.minecraft.potion.effect.slow_falling": "Зіля тихого паданя",
  "item.minecraft.potion.effect.slowness": "Зіля помалости",
  "item.minecraft.potion.effect.strength": "Зіля силы",
  "item.minecraft.potion.effect.swiftness": "Зіля скороты",
  "item.minecraft.potion.effect.thick": "Густоє зіля",
  "item.minecraft.potion.effect.turtle_master": "Зіля корытницької силы",
  "item.minecraft.potion.effect.water": "Фляшка воды",
  "item.minecraft.potion.effect.water_breathing": "Зіля пудводного дыханя",
  "item.minecraft.potion.effect.weakness": "Зіля слабости",
  "item.minecraft.potion.effect.weaving": "Зіля плетеня",
  "item.minecraft.potion.effect.wind_charged": "Зіля вітряного выбуху",
  "item.minecraft.pottery_shard_archer": "Черепина лучника",
  "item.minecraft.pottery_shard_arms_up": "Черепина из руками над головов",
  "item.minecraft.pottery_shard_prize": "Черепина из удзначенём",
  "item.minecraft.pottery_shard_skull": "Черепина из копонёв",
  "item.minecraft.powder_snow_bucket": "Відро из пухкым снігом",
  "item.minecraft.prismarine_crystals": "Крістал прізмаріна",
  "item.minecraft.prismarine_shard": "Удломок прізмаріна",
  "item.minecraft.prize_pottery_shard": "Черепина из нагородов",
  "item.minecraft.prize_pottery_sherd": "Черепина из нагородов",
  "item.minecraft.pufferfish": "Напухач",
  "item.minecraft.pufferfish_bucket": "Відро из напухачом",
  "item.minecraft.pufferfish_spawn_egg": "Яйце из напухачом",
  "item.minecraft.pumpkin_pie": "Дынёвый колач",
  "item.minecraft.pumpkin_seeds": "Насіня дыні",
  "item.minecraft.purple_bundle": "Ліловый міщух",
  "item.minecraft.purple_dye": "Ліловоє фарбиво",
  "item.minecraft.purple_harness": "Лілові хамы",
  "item.minecraft.quartz": "Недер-кварц",
  "item.minecraft.rabbit": "Сыра труська",
  "item.minecraft.rabbit_foot": "Трусяча лабка",
  "item.minecraft.rabbit_hide": "Трусяча шкурка",
  "item.minecraft.rabbit_spawn_egg": "Яйце из труськов",
  "item.minecraft.rabbit_stew": "Ґуляш из труськы",
  "item.minecraft.raiser_armor_trim_smithing_template": "Ковачська мінта",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Мінта «Пеститель»",
  "item.minecraft.ravager_spawn_egg": "Яйце из рунтошом",
  "item.minecraft.raw_copper": "Неочищена мідь",
  "item.minecraft.raw_gold": "Неочищеноє золото",
  "item.minecraft.raw_iron": "Неочищеноє жилізо",
  "item.minecraft.recovery_compass": "Компас навертаня",
  "item.minecraft.red_bundle": "Черленый міщух",
  "item.minecraft.red_dye": "Черленоє фарбиво",
  "item.minecraft.red_harness": "Черлині хамы",
  "item.minecraft.redstone": "Редстовновый порох",
  "item.minecraft.resin_brick": "Смоляна цигла",
  "item.minecraft.resin_clump": "Грудка смолы",
  "item.minecraft.rib_armor_trim_smithing_template": "Ковачська мінта",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Мінта «Ребро»",
  "item.minecraft.rotten_flesh": "Гнилоє мнясо",
  "item.minecraft.saddle": "Сідло",
  "item.minecraft.salmon": "Сырый лосос",
  "item.minecraft.salmon_bucket": "Відро из лососом",
  "item.minecraft.salmon_spawn_egg": "Яйце из лососом",
  "item.minecraft.scrape_pottery_sherd": "Черепина из фийсов",
  "item.minecraft.scute": "Дощочка",
  "item.minecraft.sentry_armor_trim_smithing_template": "Ковачська мінта",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Мінта «Шілбак»",
  "item.minecraft.shaper_armor_trim_smithing_template": "Ковачська мінта",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Мінта «Скулптор»",
  "item.minecraft.sheaf_pottery_shard": "Черепина из жмытом",
  "item.minecraft.sheaf_pottery_sherd": "Черепина из жмытом",
  "item.minecraft.shears": "Стрыжкы",
  "item.minecraft.sheep_spawn_egg": "Яйце из вуцёв",
  "item.minecraft.shelter_pottery_shard": "Черепина из прибіжищом",
  "item.minecraft.shelter_pottery_sherd": "Черепина из прибіжищом",
  "item.minecraft.shield": "Щит",
  "item.minecraft.shield.black": "Чорный щит",
  "item.minecraft.shield.blue": "Синьый щит",
  "item.minecraft.shield.brown": "Барнастый щит",
  "item.minecraft.shield.cyan": "Ціановый щит",
  "item.minecraft.shield.gray": "Сірый щит",
  "item.minecraft.shield.green": "Зеленый щит",
  "item.minecraft.shield.light_blue": "Голубый  щит",
  "item.minecraft.shield.light_gray": "Світлосірый щит",
  "item.minecraft.shield.lime": "Лаймовый щит",
  "item.minecraft.shield.magenta": "Пурпуровый щит",
  "item.minecraft.shield.orange": "Оранджовый щит",
  "item.minecraft.shield.pink": "Ружовый щит",
  "item.minecraft.shield.purple": "Ліловый щит",
  "item.minecraft.shield.red": "Черленый щит",
  "item.minecraft.shield.white": "Білый щит",
  "item.minecraft.shield.yellow": "Жовтый щит",
  "item.minecraft.shulker_shell": "Шалкерова шкарупа",
  "item.minecraft.shulker_spawn_egg": "Яйце из шалкером",
  "item.minecraft.sign": "Табличка",
  "item.minecraft.silence_armor_trim_smithing_template": "Ковачська мінта",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Мінта «Тишина»",
  "item.minecraft.silverfish_spawn_egg": "Яйце из шупавницёв",
  "item.minecraft.skeleton_horse_spawn_egg": "Яйце из конём-кустяком",
  "item.minecraft.skeleton_spawn_egg": "Яйце из кустяком",
  "item.minecraft.skull_banner_pattern": "Мінта фаны",
  "item.minecraft.skull_banner_pattern.desc": "Значка копоні",
  "item.minecraft.skull_banner_pattern.new": "Мінта «Копоня»",
  "item.minecraft.skull_pottery_shard": "Черепина из копонёв",
  "item.minecraft.skull_pottery_sherd": "Черепина из копонёв",
  "item.minecraft.slime_ball": "Ковтя слизу",
  "item.minecraft.slime_spawn_egg": "Яйце из слызаком",
  "item.minecraft.smithing_template": "Ковачська мінта",
  "item.minecraft.smithing_template.applies_to": "Парує на:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Додате удливок вадь крістал",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Броні",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Додате дараб броні",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Удливкы а крісталы",
  "item.minecraft.smithing_template.ingredients": "Інґредіенты:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Додате недерітовый удливок",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Діямантова серсама",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Додайте діямантові броні, оружіє вадь cерсаму",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Недерітовый удливок",
  "item.minecraft.smithing_template.upgrade": "Уліпшеня: ",
  "item.minecraft.sniffer_spawn_egg": "Яйце из пахачом",
  "item.minecraft.snort_pottery_shard": "Черепина пахача",
  "item.minecraft.snort_pottery_sherd": "Черепина пахача",
  "item.minecraft.snout_armor_trim_smithing_template": "Ковачська мінта",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Мінта «Фаца»",
  "item.minecraft.snow_golem_spawn_egg": "Яйце из снігуляком",
  "item.minecraft.snowball": "Снігова грудка",
  "item.minecraft.spectral_arrow": "Спектрална стріла",
  "item.minecraft.spider_eye": "Паучоє око",
  "item.minecraft.spider_spawn_egg": "Яйце из пауком",
  "item.minecraft.spire_armor_trim_smithing_template": "Ковачська мінта",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Мінта «Шпіц»",
  "item.minecraft.splash_potion": "Метателноє зіля",
  "item.minecraft.splash_potion.effect.awkward": "Метателноє чудноє зіля",
  "item.minecraft.splash_potion.effect.empty": "Метателноє несоздаваймоє зіля",
  "item.minecraft.splash_potion.effect.fire_resistance": "Метателноє зіля огнёстуйкости",
  "item.minecraft.splash_potion.effect.harming": "Метателноє зіля уразеня",
  "item.minecraft.splash_potion.effect.healing": "Метателноє зіля ліченя",
  "item.minecraft.splash_potion.effect.infested": "Метателноє зіля зараженя",
  "item.minecraft.splash_potion.effect.invisibility": "Метателноє зіля невидимости",
  "item.minecraft.splash_potion.effect.leaping": "Метателноє зіля скочности",
  "item.minecraft.splash_potion.effect.levitation": "Метателноє зіля левітації",
  "item.minecraft.splash_potion.effect.luck": "Метателноє зіля серинчі",
  "item.minecraft.splash_potion.effect.mundane": "Метателноє обычайноє зіля",
  "item.minecraft.splash_potion.effect.night_vision": "Метателноє зіля нучного нику",
  "item.minecraft.splash_potion.effect.oozing": "Метателноє зіля ликавости",
  "item.minecraft.splash_potion.effect.poison": "Метателноє зіля утровы",
  "item.minecraft.splash_potion.effect.regeneration": "Метателноє зіля реґенерації",
  "item.minecraft.splash_potion.effect.slow_falling": "Метателноє зіля тихого паданя",
  "item.minecraft.splash_potion.effect.slowness": "Метателноє зіля помалости",
  "item.minecraft.splash_potion.effect.strength": "Метателноє зіля силы",
  "item.minecraft.splash_potion.effect.swiftness": "Метателноє зіля скороты",
  "item.minecraft.splash_potion.effect.thick": "Метателноє густоє зіля",
  "item.minecraft.splash_potion.effect.turtle_master": "Метателноє зіля корытницької силы",
  "item.minecraft.splash_potion.effect.water": "Убухова фляшка воды",
  "item.minecraft.splash_potion.effect.water_breathing": "Метателноє зіля водяного дыханя",
  "item.minecraft.splash_potion.effect.weakness": "Метателноє зіля слабости",
  "item.minecraft.splash_potion.effect.weaving": "Метателноє зіля плетеня",
  "item.minecraft.splash_potion.effect.wind_charged": "Метателноє зіля вітряного выбуху",
  "item.minecraft.spruce_boat": "Смерекова лодька",
  "item.minecraft.spruce_chest_boat": "Смерекова лодька из ладов",
  "item.minecraft.spyglass": "Кукер",
  "item.minecraft.squid_spawn_egg": "Яйце из каламарём",
  "item.minecraft.stick": "Тычка",
  "item.minecraft.stone_axe": "Камняна фийса",
  "item.minecraft.stone_hoe": "Камняна копачка",
  "item.minecraft.stone_pickaxe": "Камняный чекан",
  "item.minecraft.stone_shovel": "Камняна лопата",
  "item.minecraft.stone_spear": "Камняна піка",
  "item.minecraft.stone_sword": "Камняный меч",
  "item.minecraft.stray_spawn_egg": "Яйце из блудёшом",
  "item.minecraft.strider_spawn_egg": "Яйце из блындачом",
  "item.minecraft.string": "Нитка",
  "item.minecraft.sugar": "Цукор",
  "item.minecraft.suspicious_stew": "Чудный пиркель",
  "item.minecraft.sweet_berries": "Солодкі ягоды",
  "item.minecraft.tadpole_bucket": "Відро из пуголовком",
  "item.minecraft.tadpole_spawn_egg": "Яйце из пуголовком",
  "item.minecraft.tide_armor_trim_smithing_template": "Ковачська мінта",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Мінта «Прилив»",
  "item.minecraft.tipped_arrow": "Замачана стріла",
  "item.minecraft.tipped_arrow.effect.awkward": "Замачана стріла",
  "item.minecraft.tipped_arrow.effect.empty": "Уброблена несоздавайма стріла",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Стріла огнёстуйкости",
  "item.minecraft.tipped_arrow.effect.harming": "Стріла уразеня",
  "item.minecraft.tipped_arrow.effect.healing": "Стріла ліченя",
  "item.minecraft.tipped_arrow.effect.infested": "Стріла зараженя",
  "item.minecraft.tipped_arrow.effect.invisibility": "Стріла невидимости",
  "item.minecraft.tipped_arrow.effect.leaping": "Стріла скочности",
  "item.minecraft.tipped_arrow.effect.levitation": "Стріла левітації",
  "item.minecraft.tipped_arrow.effect.luck": "Стріла серинчи",
  "item.minecraft.tipped_arrow.effect.mundane": "Замачана стріла",
  "item.minecraft.tipped_arrow.effect.night_vision": "Стріла нучного нику",
  "item.minecraft.tipped_arrow.effect.oozing": "Стріла липкавости",
  "item.minecraft.tipped_arrow.effect.poison": "Утровна стріла",
  "item.minecraft.tipped_arrow.effect.regeneration": "Стріла гоиня",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Стріла тихого паданя",
  "item.minecraft.tipped_arrow.effect.slowness": "Стріла помалости",
  "item.minecraft.tipped_arrow.effect.strength": "Стріла силы",
  "item.minecraft.tipped_arrow.effect.swiftness": "Стріла скороты",
  "item.minecraft.tipped_arrow.effect.thick": "Замачана стріла",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Стріла корытницької силы",
  "item.minecraft.tipped_arrow.effect.water": "Стріла выбуховости",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Стріла пудводного дыханя",
  "item.minecraft.tipped_arrow.effect.weakness": "Стріла слабости",
  "item.minecraft.tipped_arrow.effect.weaving": "Стріла плетеня",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Стріла вітряного выбуху",
  "item.minecraft.tnt_minecart": "Возик из дінамітом",
  "item.minecraft.torchflower_seeds": "Насіня факлёвкы",
  "item.minecraft.totem_of_undying": "Тотем безсмертія",
  "item.minecraft.trader_llama_spawn_egg": "Яйце из шефтарёвов ламов",
  "item.minecraft.trial_key": "Ключ испыток",
  "item.minecraft.trident": "Тризубиць",
  "item.minecraft.tropical_fish": "Тропічна рыба",
  "item.minecraft.tropical_fish_bucket": "Відро из тропічнов рыбов",
  "item.minecraft.tropical_fish_spawn_egg": "Яйце из тропічнов рыбов",
  "item.minecraft.turtle_helmet": "Корытко корытниці",
  "item.minecraft.turtle_scute": "Дощочка корытниці",
  "item.minecraft.turtle_spawn_egg": "Яйце из корытницёв",
  "item.minecraft.vex_armor_trim_smithing_template": "Ковачська мінта",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Мінта «Противняк»",
  "item.minecraft.vex_spawn_egg": "Яйце из противняком",
  "item.minecraft.villager_spawn_egg": "Яйце из силянином",
  "item.minecraft.vindicator_spawn_egg": "Яйце из комбатантом",
  "item.minecraft.wandering_trader_spawn_egg": "Яйце из вандрувным шефтарём",
  "item.minecraft.ward_armor_trim_smithing_template": "Ковачська мінта",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Мінта «Сокотач»",
  "item.minecraft.warden_spawn_egg": "Яйце из варташом",
  "item.minecraft.warped_fungus_on_a_stick": "Покрученый гриб на тычци",
  "item.minecraft.water_bucket": "Відро воды",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Ковачська мінта",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Мінта «Проводырь»",
  "item.minecraft.wheat": "Пшениця",
  "item.minecraft.wheat_seeds": "Насіня пшениці",
  "item.minecraft.white_bundle": "Білый міщух",
  "item.minecraft.white_dye": "Білоє фарбиво",
  "item.minecraft.white_harness": "Білі хамы",
  "item.minecraft.wild_armor_trim_smithing_template": "Ковачська мінта",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Мінта «Гущава»",
  "item.minecraft.wind_charge": "Вітряный набуй",
  "item.minecraft.witch_spawn_egg": "Яйце из босорканёв",
  "item.minecraft.wither_skeleton_spawn_egg": "Яйце из візер-кустяком",
  "item.minecraft.wither_spawn_egg": "Яйце из відером",
  "item.minecraft.wolf_armor": "Вовчі броні",
  "item.minecraft.wolf_spawn_egg": "Яйце из вовком",
  "item.minecraft.wooden_axe": "Деривляна фийса",
  "item.minecraft.wooden_hoe": "Деривляна копачка",
  "item.minecraft.wooden_pickaxe": "Деривляный чекан",
  "item.minecraft.wooden_shovel": "Деривляна лопата",
  "item.minecraft.wooden_spear": "Деривляна піка",
  "item.minecraft.wooden_sword": "Деривляный меч",
  "item.minecraft.writable_book": "Книга тай перо",
  "item.minecraft.written_book": "Написана книжка",
  "item.minecraft.yellow_bundle": "Жовтый міщух",
  "item.minecraft.yellow_dye": "Жовтоє фарбиво",
  "item.minecraft.yellow_harness": "Жовті хамы",
  "item.minecraft.zoglin_spawn_egg": "Яйце из зоґліном",
  "item.minecraft.zombie_horse_spawn_egg": "Яйце из конём-зомбіём",
  "item.minecraft.zombie_nautilus_spawn_egg": "Яйце из наутілусом-зомбійом",
  "item.minecraft.zombie_spawn_egg": "Яйце из зомбіём",
  "item.minecraft.zombie_villager_spawn_egg": "Яйце из силянином-зомбіём",
  "item.minecraft.zombified_piglin_spawn_egg": "Яйце из зомбіфіцірованым піґліном"
}
export const ry_ua = items; 
